import { Component, ViewChild, ElementRef, OnInit, Renderer2, EventEmitter, Output, HostListener, AfterViewInit, OnDestroy, Input, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import {Section} from './Section'
import {Card} from './card'
import {  FormControl, FormGroup, NgForm } from '@angular/forms';
import { Validators, Editor, Toolbar } from 'ngx-editor';
import { ColourPickerService } from '../colour-picker/colour-picker.service';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../shared/common.service';
import { BoardService } from './board.service';
import { Board } from './Board';
import { uploadFile } from '../shared/azure-storage';
import { trigger, state, style, transition, animate, keyframes } from '@angular/animations';
import { Media } from './Media';
import { AudioRecorderService } from '../shared/audio-recorder.service';
import { AngularFireDatabase } from '@angular/fire/compat/database';
import 'firebase/database'
import { Router } from '@angular/router';
import { SearchService } from '../shared/search.service';
import { User } from './User';
import { ModelServiceService } from '../shared/model-service.service';
import { TranslationService } from '../shared/translation.service';
import Swal from 'sweetalert2';
import { RlToastService } from '../shared/rl-toast.service';
import { ProfileOptionItem } from './profile.model';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Subject, fromEvent, takeUntil } from 'rxjs';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
declare var $: any;
@Component({
  selector: 'app-board',
  templateUrl: './board.component.html',
  styleUrls: ['./board.component.css'],
  animations: [
    trigger('movementtrigger', [
      state('nextevent', style({ opacity: 1 })),
      state('prevevent', style({ opacity: 1 })),
      transition('* => nextevent', [
        animate(500, keyframes([
          style({ opacity: 1, transform: 'rotate3d(0, 1, 0, 0deg)' }),
          style({ opacity: 0, transform: 'rotate3d(0, 1, 0, 90deg)' }),
          style({ opacity: 0, transform: 'rotate3d(0, 1, 0, 180deg)' }),
          style({ opacity: 1, transform: 'rotate3d(0, 1, 0, 180deg)' })
        ]))
      ]),
      transition('* => prevevent', [
        animate(500, keyframes([
          style({ opacity: 1, transform: 'rotate3d(0, 1, 0, 0deg)' }),
          style({ opacity: 0, transform: 'rotate3d(0, 1, 0, -90deg)' }),
          style({ opacity: 0, transform: 'rotate3d(0, 1, 0, -180deg)' }),
          style({ opacity: 1, transform: 'rotate3d(0, 1, 0, -180deg)' })
        ]))
      ]),
    ]),
    trigger('fadeInUp', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateY(20px)' }),
        animate('300ms', style({ opacity: 1, transform: 'translateY(0)' })),
      ]),
    ]),
  ]
})

export class BoardComponent implements OnInit,OnDestroy{
  goBoardHt=""
  goGameFlag:boolean=false;
  goToGameFlag:boolean=false;
  reactionDeleteSelectedCard=0;
  boardOptionClass=""
  selectedUser:string=''
  ipadClass="noSideBar"
  leftBarHidedeFlag:boolean=false;
  leftBarHideClass='content-page-without-sidebar';
  isScrolling: boolean = false;
  smoothScrollTimeout:any;
  switchType='assignment';
  toggleClassAssignment="activeBoard"
  toggleClassPersonal="switch"
  isToggled: boolean = false;
  deleteCommentCardId;
  deleteCommentId;
  deleteCommentSectionId;
  deleteCommentFlag:boolean=false;
  cardUserId=0
  cardComment: Card = {cardOwnerName:"",cardId:"", cardTitle: 0,cardDesc: 'Default Title',cardRating:0,cardComment:[{name:"",id:0,text:"",avatar:"",editCommentFlag:false,user_id:0}],cardLike:false,cardLikeCount:0,cardCreatedDate:new Date(),
  headerColour:'',cardProfileImg:"",fileCount:0,sectionId:0,userId:0,boardId:0,cardExpandFlag:false,comments_count:0,media:[],commentText:"",user_info:[],showReaction:false,showReactionEdit:false,reactions:[],reactionCount:0,lastThreeReaction:[],reactionBag:"",reactionIconClass:"",thumbnail:[],sdg_tags:[],cardAnimationClass:''};
  tagSdg=[];
  sectionHeaderClass=""
  deletedBoardType='';
  setUserPermission='write';
  animateOnLoad = true;
  thumbnailImage="";
  email="";
  dragCardId;
  dragSectionId;
  c=[];
  carouselImages: string[] = [];
  @Input() layoutType: string = '';
  @Input() leftSidebarTheme: string = 'light';
  profileOptions: ProfileOptionItem[] = [];
  viewSectionFlag:boolean=false;
  deleteBoardFlag:boolean=false;
  deleteSectionFlag:boolean=false;
  deleteCardFlag:boolean=false;
  deleteConfiremText=""
  fireBaseChildChanged;
  fireBaseChildRemove;
  fireBaseChildAdded;
  refCount=0;
  refrence:any;
  msgString="";
  cssForDisableArrowsNext;
  cssForDisableArrowsPre;
  boardFilterType="assignment";
  selectedReaction: 'like' | 'love' | 'haha' | 'wow' | 'sad' | 'angry' | null = null;  searchForm: FormGroup;
  gamerPermissions='Admin'
  selectedImageIndex=1;
  boardBagImage="demo1";
  inviteSelectedUseList: User[] = [];;
  searchInviterUser: string = '';
  searchFilteredUsers : User[] = [];
  selectedUsers: User[] = []; // Array to manage selected users
  deletedBoardId:any;
  deletedSectionId:any;
  deleteTedCardId:any;
  imageVideo:any=[];
  file:any=[];
  audio:any=[];
  expandFilterFlag:boolean=false;
  boardIconflag:boolean=false;
  msgText="";
  successMsgFlag:boolean=true;
  private existingKeys: Set<string> = new Set();
  private initialLoadComplete: boolean = false;
  private localData: { [key: string]: any } = {};
  commentText="";
  editCommentFlag:boolean=false;
  editCommentText="";
  editCommentObj;
  editCommentId=0;
  //web search
  search: string = '';
  imagesSerach: any[] = [];
  videosSearch: any[] = [];
  searchSelectedImages:any=null;
  searchSelectedVideos:any=null;
  imageSearchFlag:boolean=true;
  imageActive="active"
  videoSearchFlag:boolean=false;
  videoActive=""
  // web search end
  //edit board
editBoardFlag:boolean=false;
boardEditTitle="";
boardEditDesc=""
boardId;
editBoardBagId;
  // edit card
  cardRating=0;
  cardEditFlag:boolean=false;
  count=0;
  cardEditTitle="";
  cardEditDesc="";
  cards:Card[]=[]
  cardView: Card = {cardOwnerName:"",cardId:"", cardTitle: 0,cardDesc: 'Default Title',cardRating:0,cardComment:[{name:"",id:0,text:"",avatar:"",editCommentFlag:false,user_id:0}],cardLike:false,cardLikeCount:0,cardCreatedDate:new Date(),
  headerColour:'',cardProfileImg:"",fileCount:0,sectionId:0,userId:0,boardId:0,cardExpandFlag:false,comments_count:0,media:[],commentText:"",user_info:[],showReaction:false,showReactionEdit:false,reactions:[],reactionCount:0,lastThreeReaction:[],reactionBag:"",reactionIconClass:"",thumbnail:[],sdg_tags:[],cardAnimationClass:''
  }
  newComment=""
  viewCardProfile;
  viewCardUserId;
  viewCardComment:Comment[];
  // edit cardEnd

  // edit section
  sectionEditFlag:boolean=false;
  sectionEditTitle="";
  editSectionDesc="";
  sectionProfileChange;
  sectionView:Section={sectionName:"",sectionId:"",sectionDesc:"",splitesDesc:[],sectionTitleImage:"",sectionImage:"",sectionVideo:"",sectionFile:[],sectionStyle:"",sectionColour:'',cards:[],sectionProImage:"",boardId:0,sectionExpandFlag:false,media:[],fileCount:0,section_order:0, user_info: {
    name: '',
    username: '',
    drole: '',
    avatar: ''
  }};
  editSectionProfile;
  expandedSection: any = null;
  expandSectionCardOpen = false;

  // edit section end

  media=new Media()
  sectionForm: FormGroup;
  isRotated = false;
  state: string = 'nextevent';
  innerState:string='nextevent'
 azureSasKey ='';
  pictureList:string[]=[];
  afterFilterList:any=[];
  finalMedia;
  uploadedFileArray:any=[];
  mostCommntedCardFilter:boolean=false
  filterForm: FormGroup;
  selectedName;
  searchText;
  boardSearch;
  boardName="";
  boardDescription="";
  deafaultCardColour=''
  addCardSectionId:any;
  selectedSectionName:any;
  showMore = false;
  thumbsUpCount: number = 0;
  sectionData:any=[];
  allBoard: Board[]=[];
  imageArr:any=[];
  videoArr:any=[];
  fileArr:any=[];
  activeBoardIcon="activeIcon";
  activeClassHome="";
  activeClassAanlytical="";
  profilePicture:any='';
  cardExpand:boolean=false;
  expandFlag:boolean=false;
  section: Section[] = [];
  card: Card[] = [];
  showReaction:boolean=false;
   sectionName="";
   cardName="";
   sectionDesc="";
   cardTitle='';
   cardDesc="";
   url:any;
   fileUrl:any;
  format:any;
  public formStar: FormGroup;
   editorTitle: Editor;//view card title
   editorDesc: Editor;//view card desc

   addTitleCard: Editor;//add card
   addDescCard: Editor;//add card 

   editorTitleSection: Editor //view section;
   editorDescSection: Editor; //view section

   editorTitleBoard: Editor;//add board
   editorDescBoard: Editor;//add board

   boardEditTitleEd:Editor; //edit board
   bordEditDescEd:Editor ;//edit board

   sectionCreateTitle:Editor;// 
   sectionCreateDesc:Editor;//add section
   toolbar: Toolbar = [['bold', 'italic'], ['underline']];
   toolbar1: Toolbar = [['bold', 'italic'], ['underline']];
  starRating =0;
  private unsubscriber: Subject<void> = new Subject<void>();
  color = new FormControl('', Validators.required());
  sectionMediaTab = 'image';
  cardMediaTab = 'image';
  sectionColorSwatches = [
    '#7c5cfc', '#f472b6', '#fb923c', '#facc15', '#4ade80',
    '#2dd4bf', '#38bdf8', '#60a5fa', '#a78bfa'
  ];

  activeEditorSection: string = 'editorTitleSection'; // Default active editor
  activeEditorCard: string = 'editorTitle'; // Default active editor
  activeEditorBoard: string = 'editorTitleBoard'; // Default active editor
  activeEditorEditBoard:string='boardEditTitleEd';
  activeAddCard:string="addTitleCard"
  isRecording = false;
  recordedTime;
  audioLevels: number[] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
  blobUrl;
  teste;
  storageUrl;
  getLitFlag:boolean=false;
  isFullscreen = false;

  //reaction
  reactionActiveTabIndex = 0;
  reactionTab=[]
  isPlaying = false;
  progressStyle = 'conic-gradient(#f00 0%, #ddd 0%)';
  lightboxAudioPlaying = false;
  lightboxAudioCurrent = 0;
  lightboxAudioDuration = 0;
  lightboxAudioMuted = false;
  lightboxAudioVolume = 1;
  @Output() clickOutside = new EventEmitter<void>();
  @ViewChild('audioPlayer') audioPlayer: ElementRef<HTMLAudioElement>;
  @ViewChild('audioPlayernew') audioPlayerRef: ElementRef<HTMLAudioElement>;
  @ViewChild('scrollableDiv') scrollableDiv: ElementRef;
  @ViewChild('videoPlayer', { static: false }) videoPlayerRef!: ElementRef<HTMLVideoElement>;
  @ViewChild('boardDescEditor') boardDescEditor: ElementRef<HTMLDivElement>;
  @ViewChild('sectionDescEditor') sectionDescEditor: ElementRef<HTMLDivElement>;
  @ViewChild('sectionEditDescEditor') sectionEditDescEditor: ElementRef<HTMLDivElement>;
  @ViewChild('cardDescEditor') cardDescEditor: ElementRef<HTMLDivElement>;
  @ViewChild('cardEditDescEditor') cardEditDescEditor: ElementRef<HTMLDivElement>;
  @ViewChild('boardEditDescEditor') boardEditDescEditor: ElementRef<HTMLDivElement>;
    currentlyPlayingMedia: any = null; 
  constructor(
    public colourPickerService:ColourPickerService,
    public sanitizer: DomSanitizer,
    private cdr: ChangeDetectorRef,
    public searchService: SearchService,
    public audioRecordingService:AudioRecorderService,
    public boardService:BoardService,
    private renderer: Renderer2,
    private router: Router,
    public translate: TranslateService,
    public modelService:ModelServiceService,
    public translationService:TranslationService,
    public commonService: CommonService,public db:AngularFireDatabase,
    private rlToastService: RlToastService) {
    this.selectSectionColor(this.sectionColorSwatches[0]);
    this.color.valueChanges.subscribe(c=>{
    })
    this.audioRecordingService
    .recordingFailed()
    .subscribe(() => {
      this.isRecording = false;
      this.audioLevels = this.audioLevels.map(() => 0);
    });
  this.audioRecordingService
    .getRecordedTime()
    .subscribe((time) => (this.recordedTime = time));
  this.audioRecordingService.getLevels().subscribe((levels) => {
    if (!levels) {
      return;
    }
    for (let i = 0; i < this.audioLevels.length; i++) {
      this.audioLevels[i] = levels[i] || 0;
    }
    this.cdr.detectChanges();
  });
    this.audioRecordingService.getRecordedBlob().subscribe((data) => {
      this.blobUrl='';
      this.teste = data;
      this.format='audio'
      if(this.boardService.audioCount===0){
        const mp3Blob = new Blob([data.blob], { type: 'audio/mp3' });
        this.blobUrl = URL.createObjectURL(mp3Blob);
        
            // this.blobUrl = this.sanitizer.bypassSecurityTrustUrl(
            //   URL.createObjectURL(data.blob)
            // )
            this.uploadedFileArray.push({name:new Date().getTime()+"_recorded-audio.mpeg",type:this.format,url:'',size:0,displayUrl:this.blobUrl,actualFile:data.blob,edit:false})
          }
          else{
            this.openModal('confirm1')
            this.msgText=(this.translate.instant('gameLabel.You_only_select_one_audio_for_one_card'))
          }
        })
        
        setTimeout(() => {this.commonService.cardId=0 }, 10000);
          setTimeout(()=>{ this.resetScroll()},10000)
      }



  ngOnInit() {
    this.bindStackedModals();
    this.commonService.loaderFlag = true;
    if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
      this.reloadPage()
    }
    else{
    if (!this.commonService.user) {
      this.commonService.loaderFlag = false;
      console.error('Missing user session. Open via /?token=... then navigate to /board.');
      return;
    }
    if(this.commonService.user.drole==='Gamer'){
      this.boardOptionClass='boardHeaderGamer'
    }
    else{
        this.boardOptionClass='boardHeaderOther'
    }
    if(window.opener){
      this.goToGameFlag=true;
    }
    else{
      this.goToGameFlag=false;
    }
        this.commonService.loaderFlag=true;
    this.editorTitle = new Editor();
    this.editorDesc = new Editor();
    this.editorTitleSection = new Editor();
    this.editorDescSection = new Editor();
    this.editorTitleBoard = new Editor();
    this.editorDescBoard = new Editor();
    this.boardEditTitleEd=new Editor();
    this.bordEditDescEd=new Editor();
    this.sectionCreateTitle=new Editor();
    this.sectionCreateDesc=new Editor();
    this.addTitleCard=new Editor();
    this.addDescCard=new Editor();
    this._fetchProfileOptions();
    history.pushState(null, '');
    fromEvent(window, 'popstate')
      .pipe(takeUntil(this.unsubscriber))
      .subscribe((_) => {
        history.pushState(null, '');
      });
    let path='notification/user_' + this.commonService.user.id;
    const ref = this.db.database.ref(path);
    ref.on('child_changed', (snapshot) => {
      const changedChildKey = snapshot.key;
      const newData = snapshot.val();
      this.boardService.getNotification(this.commonService.user.id).subscribe(
        res=>{
          this.boardService.allNotifications=res.Result;
          this.boardService.notificationCount=res.Result.length;
          this.sweetSucees(this.translate.instant('gameLabel.New_notification_comming'));
        }
      )
    })
    
    if(this.commonService.boardIdFromGame===0){
    this.boardService.getInviteUserListForSchool().subscribe(
      res=>{
         this.boardService.users=res;
        this.boardService.getAllBoardData(this.commonService.userId).subscribe(
          res=>{
            this.allBoard=[...res.Result];
            this.commonService.loaderFlag=false;
            this.boardService.notificationCount=res.notification_count
            this.boardService.activeBoardBagImage='assets/images/Board/background-img.svg'
          },
          err => { this.commonService.loaderFlag=false; console.error('Error loading boards', err); }) 
      },
      err => { this.commonService.loaderFlag=false; console.error('Error loading users', err); })
    }
    else{
      this.boardService.getInviteUserListForSchool().subscribe(
        res=>{
           this.boardService.users=res;
           this.selectedBoard(this.commonService.boardIdFromGame,'');
           this.boardService.getAllBoardData(this.commonService.userId).subscribe(
            res=>{
              this.allBoard=[...res.Result];
              this.commonService.loaderFlag=false;
              this.boardService.notificationCount=res.notification_count
              this.commonService.loaderFlag=false;
              this.sweetSucees(this.translate.instant('gameLabel.card_added'));
            },
            err => { this.commonService.loaderFlag=false; console.error('Error loading boards', err); })
        },
        err => { this.commonService.loaderFlag=false; console.error('Error loading users', err); })
    }
   if(this.commonService.user.drole==='Gamer'){
    this.boardFilterType='all'
   }
  }
  }


  addBoard(){
    let newBoard=new Board();
    newBoard.name=this.boardName;
    newBoard.description=this.boardDescription;
    newBoard.back_image=this.selectedImageIndex;
    newBoard.user_id=this.commonService.userId;
    this.boardService.addBoard(newBoard).subscribe(
      res=>{
        newBoard=res.Result;
        this.allBoard = [...this.allBoard, newBoard];
        this.emptyAllFields();
        this.selectedImageIndex=5;
        this.boardFilterType='all';
        this.cdr.detectChanges();
         this.toggleClassPersonal="activeBoard"
         this.toggleClassAssignment="switch"
        let text=this.commonService.removeHTMLTags(newBoard.name)
        this.translate.get('gameLabel.board_added',{boardName:text}).subscribe(
          (str)=>{
               this.msgString=str
               this.sweetSucees(this.msgString);
                 } )
      } )
  }

  editBoard(board){
   this.editBoardFlag=true;
   this.editBoardBagId=parseInt(board.back_image )
   this.boardEditTitle=this.commonService.removeHTMLTags(board.name || '');
   this.boardEditDesc=board.description || board.desc || '';
   this.boardId=board.board_id;
   setTimeout(() => {
     if (this.boardEditDescEditor?.nativeElement) {
       this.boardEditDescEditor.nativeElement.innerHTML = this.boardEditDesc;
     }
   });
  }

  editBoardSave(){
    this.editBoardFlag=false;
    let updateBoard={
      name:this.boardEditTitle,
      desc:this.boardEditDesc,
      description:this.boardEditDesc,
      back_image:this.editBoardBagId,
      boardId:this.boardId
    }
    this.boardService.updateBoard(updateBoard).subscribe(
      res=>{
        for(let i=0;i<this.allBoard.length;i++){
          if(this.boardId===this.allBoard[i].board_id){
            this.allBoard[i]=res.Result;
            this.allBoard = [...this.allBoard];
            if(res.Result.type==='assignment'){
               this.boardFilterType='other'
               this.cdr.detectChanges(); 
                this.toggleClassAssignment="activeBoard"
                this.toggleClassPersonal="switch"
                this.boardFilterType='assignment'
            }
            else{
              this.boardFilterType='all'
              this.cdr.detectChanges(); 
              this.toggleClassPersonal="activeBoard"
              this.toggleClassAssignment="switch"
              this.boardFilterType='all';
            }
            this.boardEditTitle='';
            this.boardEditDesc=''
            break
           
          }
        }
        // let text=this.commonService.removeHTMLTags(res.Result.name)
        // this.translate.get('gameLabel.board_updated',{boardName:text}).subscribe(
        //   (str)=>{
        //        this.msgString=str
        //        this.sweetSucees(this.msgString);
              //  alert("Board updated succesfully")
                //  } )
      })
  }
  addSection(){
    this.commonService.loaderFlag=true;
    this.successMsgFlag=false;
    let addedSection=new Section();
    addedSection.sectionName=this.sectionName;
    addedSection.sectionDesc=this.sectionDesc;
    addedSection.sectionColour=this.colourPickerService.selctedColor;
    (addedSection as any).color=this.colourPickerService.selctedColor;
    addedSection.sectionFile=this.fileArr
    addedSection.sectionImage=this.imageArr
    addedSection.sectionStyle=''
    addedSection.sectionId='';
    addedSection.sectionTitleImage='';
    addedSection.sectionVideo=this.videoArr
    addedSection.sectionExpandFlag=false;
    addedSection.boardId= this.boardService.activeBoardId
    addedSection.section_order=this.boardService.section.length
    addedSection.cards=[]
    this.section.push(addedSection)
  this.getMediaData('Section').then(() => {
    addedSection.media=this.commonService.createMediaArray(this.uploadedFileArray) 
      this.boardService.createSection(addedSection).subscribe(
      res=>{
        if(this.boardService.section.length>0){
          const index =   this.boardService.section.findIndex(section => section.sectionId ===res.sectionId); 
          if(index===-1){
            this.boardService.section.push(this.withSectionColor(res, addedSection.sectionColour))
            this.emptyAllFields();
            this.commonService.loaderFlag=false;
              this.boardService.sectionCopy=JSON.parse(JSON.stringify(this.boardService.section));
              this.boardService.currentSelectedSection=this.boardService.section[0];
              this.boardService.currentSelectedSection.cards=this.boardService.section[0].cards;
              // }
              this.translate.get(('gameLabel.Section_Added'),{sectionName:addedSection.sectionName}).subscribe(
                res=>{
                  this.sweetSucees(res);
                })
          }
         }
        else{          
        this.boardService.section.push(this.withSectionColor(res, addedSection.sectionColour))
        this.emptyAllFields();
        this.commonService.loaderFlag=false;
          this.boardService.sectionCopy=JSON.parse(JSON.stringify(this.boardService.section));
          this.boardService.currentSelectedSection=this.boardService.section[0];
          this.boardService.currentSelectedSection.cards=this.boardService.section[0].cards;
          // }
          this.translate.get(('gameLabel.Section_Added'),{sectionName:addedSection.sectionName}).subscribe(
            res=>{
              this.sweetSucees(res);
            })
        }
       
      })
  }).catch(error => {
    console.error('Error uploading files:', error);
  });
 
    
  }

  async getMediaData(type): Promise<void> {
    for (let i = 0; i < this.uploadedFileArray.length; i++) {
        if(this.uploadedFileArray[i].hasOwnProperty('actualFile')){
        const res = await this.boardService.getValidUrlForMediaStorage().toPromise();
        const blobUrl = await uploadFile(this.uploadedFileArray[i].actualFile, res);
        if (!blobUrl) {
          throw new Error('File upload did not return a blob URL');
        }
        this.uploadedFileArray[i].url = blobUrl;

      }
      else if(!this.uploadedFileArray[i].hasOwnProperty('displayUrl')){
        this.uploadedFileArray[i].url = this.uploadedFileArray[i].url;
        this.uploadedFileArray[i].edit=false;
      }
      else{
        this.uploadedFileArray[i].url = this.uploadedFileArray[i].displayUrl;
      }
    }
  }


  getsectionId(sectionId:any,index:any){
    this.addCardSectionId=sectionId
   this.deafaultCardColour= this.boardService.section[index].sectionColour;
   this.selectedSectionName=this.commonService.removeHTMLTags(this.boardService.section[index].sectionName);
  }
  addCard(){
    let sectionId=this.addCardSectionId;
    let newCard=new Card();
   newCard.cardId='';
   newCard.cardOwnerName=this.commonService.userName;
   newCard.cardTitle=this.cardName;
   newCard.cardDesc=this.cardDesc
   newCard.sectionId=sectionId;
   newCard.cardProfileImg='';
   newCard.thumbnail=[];
   newCard.cardExpandFlag=false;
   newCard.boardId=this.boardService.activeBoardId
  newCard.headerColour=this.deafaultCardColour
   newCard.cardExpandFlag=false;
   this.getMediaData('Card').then(() => {
    newCard.media=this.commonService.createMediaArray(this.uploadedFileArray) 
      this.boardService.createCard(newCard).subscribe(
        res=>{
        
        this.boardService.section.forEach((item) => {
         if(item.sectionId===sectionId){
          if(item.cards.length>0){
            const index = item.cards.findIndex(card => card.cardId ===res.cardId); 
           res.cardAnimationClass="animated animatedFadeInUp fadeInUp"
            if(index===-1){
              item.cards.unshift(res)
            }
          }
          else{
            item.cards.unshift(res)
          }
          // newCard.cardId=res.cardId
          // newCard.headerColour=item.sectionColour
          // newCard.cardCreatedDate=res.created_date;
         }
      });
      const sectionNameForToast = this.selectedSectionName
        || this.commonService.removeHTMLTags(
          this.boardService.section.find((s) => s.sectionId === sectionId)?.sectionName || ''
        );
      this.emptyAllFields();
      this.closeModal('addCard')
      this.translate.get('gameLabel.card_Added', { sectionName: sectionNameForToast }).subscribe(
        (str) => {
          this.msgString = str;
          this.sweetSucees(this.msgString);
          // alert("card added at +"+sectionId)
        })
      })
  }).catch(error => {
   console.error('Error uploading files:', error);
   this.msgText = 'Image upload failed. ' + (error && error.message ? error.message : '');
   this.openModal('confirm1');
  });
      
  }

  clickSectionExpand(index:any){
    this.boardService.section[index].sectionExpandFlag= !this.boardService.section[index].sectionExpandFlag
  }

  clickCardExpand(sectionIndex:any,cardId:any){
    let cards=this.boardService.section[sectionIndex].cards;
    cards.forEach((card=>{
      if(card.cardId===cardId){
        card.cardExpandFlag=!card.cardExpandFlag;
      }
    }))
  }

  openCardMediaPicker(mode: 'add' | 'edit' = 'add'): void {
    if (this.uploadedFileArray.length > 0) {
      return;
    }

    const tab = this.cardMediaTab === 'video' || this.cardMediaTab === 'file'
      ? this.cardMediaTab
      : 'image';

    if (tab === 'image' && this.boardService.imageCount >= 1) {
      return;
    }
    if (tab === 'video' && this.boardService.videoCount >= 1) {
      return;
    }
    if (tab === 'file' && this.boardService.fileCount >= 1) {
      return;
    }

    const suffix = mode === 'edit' ? 'Edit' : '';
    const inputId = tab === 'video'
      ? `fileInputVideoCard${suffix}`
      : tab === 'file'
        ? `fileInputOtherCard${suffix}`
        : `fileInputImageCard${suffix}`;

    document.getElementById(inputId)?.click();
  }

  onSelectFileInput(event:any) {
    const fileInput = event.target as HTMLInputElement;
    const file = event.target.files && event.target.files[0];
      if (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        const fileName = file.name; // Get the file name
        const fileSizeInMB = file.size / 1024 / 1024; // Convert size to MB
        let maxSize = 0;
        if (file.type.indexOf('image') > -1) {
          this.format = 'image';
          maxSize = this.commonService.maxImageSize; // Max 2 MB for images
      } else if (file.type.indexOf('video') > -1) {
          this.format = 'video';
          maxSize = this.commonService.maxVideoSize; // Max 20 MB for videos
      } else if (file.type.indexOf('pdf') > -1) {
          this.format = 'pdf';
          maxSize = this.commonService.maxFileSize; // Max 5 MB for PDFs
      } else if (file.type.indexOf('sheet') > -1) {
          this.format = 'sheet';
          maxSize = this.commonService.maxFileSize; // Max 5 MB for sheets
      } else if (file.type.indexOf('text/csv') > -1) {
          this.format = 'csv';
          maxSize = this.commonService.maxFileSize; // Max 5 MB for CSVs
      } else if (file.type === 'application/vnd.ms-powerpoint' || file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation') {
          this.format = 'ppt';
          maxSize = this.commonService.maxFileSize; // Max 5 MB for PowerPoint presentations
      } else if (file.type.indexOf('audio') > -1) {
          this.format = 'audio';
          maxSize = this.commonService.maxAudioSize; // Max 5 MB for audio files
      }

      if (fileSizeInMB > maxSize) {
          this.translate.get('gameLabel.fileSizeExceedWarning', { format: this.format, maxSize: maxSize }).subscribe(
              (str) => {
                this.openModal('confirm1')
                  this.msgText=(str); 
              }
          );
          return;
      }

        reader.onload = (event) => {
          this.url = (<FileReader>event.target).result;
          let editFlag:boolean=false;
          if(this.cardEditFlag){
            editFlag=true
          }
          else if(this.sectionEditFlag){
            editFlag=true
          }
          if(editFlag){
            if(this.format==='image' && this.boardService.imageCount===0){
              this.uploadedFileArray.push({name:file.name,type:this.format,url:'',size:Math.round(file.size/ 1024)+"KB",displayUrl:this.url,actualFile:file,edit:editFlag})
              this.boardService.imageCount=this.boardService.imageCount+1
            }
            else if(this.format==='video' && this.boardService.videoCount===0){
              this.uploadedFileArray.push({name:file.name,type:this.format,url:'',size:Math.round(file.size/ 1024)+"KB",displayUrl:this.url,actualFile:file,edit:editFlag})
              this.boardService.videoCount=this.boardService.videoCount+1
             }
             else if(((this.format==='pdf' ||this.format==='csv' ||this.format==='sheet'||this.format==='ppt') && this.boardService.fileCount===0)){
              this.uploadedFileArray.push({name:file.name,type:this.format,url:'',size:Math.round(file.size/ 1024)+"KB",displayUrl:this.url,actualFile:file,edit:editFlag})
              this.boardService.fileCount=this.boardService.fileCount+1
             } 
             else {
              this.translate.get('gameLabel.uploade_Warr',{format:this.format}).subscribe(
                (str)=>{
                     this.msgString=str
                     this.openModal('confirm1')
                     this.msgText=(this.msgString)
                } )
             }
          }
          else{
            if(this.format==='image' && this.boardService.imageCount===0){
              this.uploadedFileArray.push({name:file.name,type:this.format,url:'',size:Math.round(file.size/ 1024)+"KB",displayUrl:this.url,actualFile:file,edit:editFlag})
              this.createInnerArrayforMedia('image',this.url,this.uploadedFileArray.length-1)
    
            }
            else if(this.format==='video' && this.boardService.videoCount===0){
              this.uploadedFileArray.push({name:file.name,type:this.format,url:'',size:Math.round(file.size/ 1024)+"KB",displayUrl:this.url,actualFile:file,edit:editFlag})
              this.createInnerArrayforMedia('video',this.url,this.uploadedFileArray.length-1)
             }
             else if(((this.format==='pdf' ||this.format==='csv' ||this.format==='sheet'||this.format==='ppt') && this.boardService.fileCount===0)){
              this.uploadedFileArray.push({name:file.name,type:this.format,url:'',size:Math.round(file.size/ 1024)+"KB",displayUrl:this.url,actualFile:file,edit:editFlag})
              this.createInnerArrayforMedia('file',file.name,this.uploadedFileArray.length-1)
             } 
             else{
              this.translate.get('gameLabel.uploade_Warr',{format:this.format}).subscribe(
                (str)=>{
                     this.msgString=str
                     this.openModal('confirm1');
                    } )
             }
          }
                }
          
      }
      fileInput.value = '';
   
  }
getValue(card,rating){
  this.boardService.saveCardRating(card.cardId,card.boardId,card.sectionId,rating).subscribe(
    res=>{
      // this.boardService.fireBaseReaction=true;
      this.boardService.isBlinking=true;
      this.boardService.textBlink=this.translate.instant('gameLabel.Rating_succefully')
      setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);
    })
}

setActiveEditor(editor: string,id:any): void {
  switch(id){
     case 1:
      this.activeEditorSection = editor;
      break;
     case 2:
     this.activeEditorCard = editor;
     break;
     case 3:
     this.activeEditorBoard = editor;
     break;
     case 4:
     this.activeEditorEditBoard = editor;
     break;
     case 5:
      this.activeAddCard = editor;
      break;
    }

}

homeClick(){
this.leftBarHideClass='content-page-with-sidebar'
  this.sectionHeaderClass='headerTop'
  this.boardService.scrollClass="sectionScroll"
  this.renderer.addClass(document.body, 'dynamic-body-class');
   this.initialLoadComplete = false;
    this.existingKeys = new Set<string>();
     let path='board/board_' + this.boardService.activeBoardId;
  this.refrence = this.db.database.ref(path);
  // Load initial data
  this.refrence.once('value', snapshot => {
    this.localData = snapshot.val() || {};
    snapshot.forEach(childSnapshot => {
      this.existingKeys.add(childSnapshot.key!);
    });
    this.initialLoadComplete = true;
  });
  // if(this.refCount === 0){ 
   this.fireBaseChildChanged= this.refrence.on('child_changed', (snapshot) => {
      const changedChildKey = snapshot.key;
      const newData = snapshot.val();
      const oldData = this.localData[changedChildKey];
      const changes = this.boardService.detectChanges(oldData, newData);
          this.localData[changedChildKey] = newData;
      // console.log(`Changes in child ${changedChildKey}:`+JSON.stringify(changes));
      let section='section_';
      let card='card_';
      const changedCardKey = Object.keys(changes).find(key =>
        key !== 'changed' && key !== 'changeKey' && key.toLowerCase().includes(card)
      );
      const parts = changedChildKey.split('_');
       let sectionId=parseInt(parts[1]);
       if(changes.changeKey===""&& !changes.changed){
        this.boardService.deleteCardFromFireBase(sectionId).subscribe(
          res=>{
            let sectionToUpdate = this.boardService.section.find(section => section.sectionId === sectionId);
            if (sectionToUpdate) {
              sectionToUpdate.cards= res.Result;
              this.boardService.changeSectionId=sectionId
               this.boardService.isBlinking=true;
               this.boardService.textBlink=this.translate.instant('gameLabel.Card_remove')
               setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);
            }
          })
       }
       else if(changedChildKey==='update_count'){
        this.boardService.getBoardById(this.boardService.activeBoardId).subscribe(
          res=>{
            const boardUpdate = this.allBoard.find( board =>board.board_id === this.boardService.activeBoardId);
            if(boardUpdate){
              Object.assign(boardUpdate, res);
              // let text=this.commonService.removeHTMLTags(boardUpdate.name)
              this.boardService.changeSectionId=sectionId
              this.boardService.isBlinking=true;
              this.boardService.textBlink=this.translate.instant('gameLabel.Card_update')
              setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);
              // this.sweetSucees(this.translate.instant('gameLabel.Card_updated'))
              // alert("Board update"+changes.changeKey)
  
            }
          } )
       }
       else if(changes[changes.changeKey].new===1 &&changes[changes.changeKey].old===undefined){
        this.boardService.getSectionUpdateOrAdded(sectionId,false).subscribe(
          res=>{
            const sectionToUpdate = this.boardService.section.find(section => section.sectionId === sectionId);
            if (sectionToUpdate) {
              let card=sectionToUpdate.cards
              res.cards=card;
            //  (this.boardService.fillOnlyOneSctionCount(sectionToUpdate));
              Object.assign(sectionToUpdate, res);
              this.boardService.changeSectionId=sectionToUpdate.sectionId;
               this.boardService.isBlinking=true;
               this.boardService.textBlink=this.translate.instant('gameLabel.Section_updated')
               setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);
              // let str=sectionToUpdate.sectionName
              // let text=this.commonService.removeHTMLTags(str)
              // this.translate.get('gameLabel.Section_update', { sectionName:text }).subscribe(
              //   (str) => {
              //     this.msgString = str;
              //     this.sweetSucees( this.msgString);
                  // alert("Section update+"+sectionId)
                // })
            }
          })
       }
      else  if(changes.changeKey.includes('update_count') && changes[changes.changeKey].old===undefined ){
        this.boardService.getSectionUpdateOrAdded(sectionId,true).subscribe(
          res=>{
            const sectionToUpdate = this.boardService.section.find(section => section.sectionId === sectionId);
             if(sectionToUpdate){
               (this.boardService.fillOnlyOneSctionCount(sectionToUpdate))
               if(sectionToUpdate.cards.length>0){
                const index = sectionToUpdate.cards.findIndex(card => card.cardId ===res.cardId); 
                if(index===-1){
                  Object.assign(sectionToUpdate.cards,res)
                  let str=sectionToUpdate.sectionName
                  let text=this.commonService.removeHTMLTags(str)
                  this.boardService.changeSectionId=sectionToUpdate.sectionId;
                   this.boardService.isBlinking=true;
                 this.boardService.textBlink=this.translate.instant('gameLabel.Card_added')
                 setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);
  
                }
              }
              else{
                Object.assign(sectionToUpdate.cards,res)
                let str=sectionToUpdate.sectionName
                let text=this.commonService.removeHTMLTags(str)
                this.boardService.changeSectionId=sectionToUpdate.sectionId;
                 this.boardService.isBlinking=true;
               this.boardService.textBlink=this.translate.instant('gameLabel.Card_added')
               setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);

              }
              }
        })
       }
       else if (changedChildKey.toLowerCase().includes(section.toLowerCase()) &&!changes.changeKey.includes(card)&& !changedCardKey &&changes[changes.changeKey].old!==undefined) {
        this.boardService.getSectionUpdateOrAdded(sectionId,false).subscribe(
            res=>{
              const sectionToUpdate = this.boardService.section.find(section => section.sectionId === sectionId);
              if (sectionToUpdate) {
                let card=sectionToUpdate.cards
                res.cards=card;
               (this.boardService.fillOnlyOneSctionCount(sectionToUpdate));
                Object.assign(sectionToUpdate, res);
                let str=sectionToUpdate.sectionName
                let text=this.commonService.removeHTMLTags(str)
                this.boardService.changeSectionId=sectionToUpdate.sectionId;
                 this.boardService.isBlinking=true;
               this.boardService.textBlink=this.translate.instant('gameLabel.Section_updated')
               setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);
                // this.translate.get('gameLabel.Section_update', { sectionName:text }).subscribe(
                //   (str) => {
                //     this.msgString = str;
                //     this.sweetSucees( this.msgString);
                    // alert("Section update+"+sectionId)
                  // })
              }
            })
      }
      else if(changedChildKey.toLowerCase().includes(section.toLowerCase()) && (changes.changeKey.includes(card) || !!changedCardKey)){
        const cardKey = changes.changeKey.includes(card) ? changes.changeKey : changedCardKey;
        const splits = cardKey.split('_');
        let cardId=parseInt(splits[1]);
        if(changes[cardKey].old===undefined  && changes[cardKey].hasOwnProperty('new')){
              this.boardService.getChangedCardByIdOrAddCard(cardId,false).subscribe(
                res=>{
                  const sectionToUpdate = this.boardService.section.find(section => section.sectionId === sectionId);
                   if(sectionToUpdate){
                    this.boardService.setReactionDisplay(res)
                   this.boardService.fillReactionBag(res)
                   if(sectionToUpdate.cards.length>0){
                    const index = sectionToUpdate.cards.findIndex(card => card.cardId ===res.cardId); 
                    if(index===-1){
                      sectionToUpdate.cards.unshift(res)
                      let str=sectionToUpdate.sectionName+res.cardTitle
                      let text=this.commonService.removeHTMLTags(str)
                      this.boardService.changeSectionId=sectionToUpdate.sectionId
                       this.boardService.isBlinking=true;
                       this.boardService.textBlink=this.translate.instant('gameLabel.Card_added')
                       setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);
  
                    }
                  }
                  else{
                    sectionToUpdate.cards.unshift(res)
                    let str=sectionToUpdate.sectionName+res.cardTitle
                    let text=this.commonService.removeHTMLTags(str)
                    this.boardService.changeSectionId=sectionToUpdate.sectionId
                     this.boardService.isBlinking=true;
                     this.boardService.textBlink=this.translate.instant('gameLabel.Card_added')
                     setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);

                  }
                    // sectionToUpdate.cards.push(res);
                    // sectionToUpdate.cards.unshift(res);
                  }
              })
        }
        else{
          const oldCard = changes[cardKey].old || {};
          const newCard = changes[cardKey].new || {};
          const oldCommentCount = oldCard.comment_count ?? oldCard.comments_count;
          const newCommentCount = newCard.comment_count ?? newCard.comments_count;
          if(oldCommentCount===newCommentCount){
            this.boardService.getChangedCardByIdOrAddCard(cardId,false).subscribe(
              res=>{
                const sectionToUpdate = this.boardService.section.find( newSection =>newSection.sectionId === sectionId);
                if(sectionToUpdate){
                 const updatedCard=  sectionToUpdate.cards.find(card=>card.cardId===cardId);
                 if(updatedCard){
                 let comment= updatedCard.cardComment
                 res.cardComment=comment;
                 if(updatedCard.cardId===this.boardService.editedCardId){
                  res.commentText=this.boardService.addCommmentText
                 }
                 else{
                  res.commentText=''
                 }
                for(let i=0;i<res.cardComment.length;i++){
                  if(res.cardComment[i].id===this.boardService.editedCommentId){
                    res.cardComment[i].editCommentFlag=true;
                  }
                }

                 this.boardService.setReactionDisplay(res)
                  Object.assign(updatedCard, res);
                  this.boardService.fillReactionBag(updatedCard)
                 }
                 this.boardService.changeSectionId=sectionToUpdate.sectionId;
                  this.boardService.isBlinking=true;
                  this.boardService.textBlink=this.translate.instant('gameLabel.Card_update')
                  setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);
                  this.cdr.detectChanges();
                }
              })
          }
          else{
            this.boardService.getChangedCardByIdOrAddCard(cardId,true).subscribe(
              res=>{
                const sectionToUpdate = this.boardService.section.find( newSection =>newSection.sectionId === sectionId);
                if(sectionToUpdate){
                 const updatedCard= sectionToUpdate.cards.find(card=>card.cardId===cardId);
                 if(updatedCard){
                 if(updatedCard.cardId!==this.boardService.editedCardId){
                 updatedCard.commentText="";
                 }
                  const comments = Array.isArray(res) ? res : (res?.cardComment || []);
                  updatedCard.cardComment= comments;
                for(let i=0;i<comments.length;i++){
                  if(comments[i].id===this.boardService.editedCommentId){
                    comments[i].editCommentFlag=true;
                  }
                }
                  this.boardService.fillReactionBag(updatedCard);
                 }
                 this.boardService.changeSectionId=sectionToUpdate.sectionId;
                  this.boardService.isBlinking=true;
                 this.boardService.textBlink=this.translate.instant('gameLabel.Card_comment_update')
                 setTimeout(() => {this.boardService.changeSectionId=0 ;this.boardService.isBlinking=false;this.boardService.textBlink=''}, 5000);
                  this.cdr.detectChanges();
                }
              })
          }
        }
    }
        })   
        this.fireBaseChildAdded=this.refrence.on('child_added', (snapshot) => {
      const addedKey = snapshot.key!;
        if (this.initialLoadComplete && !this.existingKeys.has(addedKey)) {
          const addedData = snapshot.val();
          this.boardService.handleChildAdded(addedKey, addedData);   
        }
      
    });
    this.fireBaseChildRemove= this.refrence.on('child_removed', (snapshot) => {
      const removedChildKey = snapshot.key; // Get the key of the removed child
      const removedChildData = snapshot.val(); // Get the data of the removed child
      // alert('Child removed: ' + removedChildData + ', Key: ' + removedChildKey);
      if(!removedChildKey.includes('section') ){
          this.commonService.boardFlag=true;
          this.commonService.homeFlag=false;
        this.commonService.analyticalBoardClick=false;
       this.activeBoardIcon="activeIcon"
       this.activeClassHome="";
        this.activeClassAanlytical="";
        this.boardService.getAllBoardData(this.commonService.userId).subscribe(
          res=>{
            this.allBoard=[...res.Result];
          this.router.navigate(['/board'])
          this.sweetSucees(this.translate.instant('gameLabel.Board_removed'));
          // alert("Remove board")f
          })
      }
      else if(removedChildKey.includes('section_')){
        const parts = removedChildKey.split('_');
       let sectionId=parseInt(parts[1]);
      let  deletedSectionId=this.boardService.section.findIndex(section=>section.sectionId===sectionId)
       if(deletedSectionId!==-1){
      this.boardService.getBoardById(this.boardService.activeBoardId).subscribe(
        res=>{
           this.boardService.section=res.sections
           for(let i=0;i<res.sections.length;i++){
            let cards=res.sections[i].cards;
            for(let j=0;j<cards.length;j++){
              this.boardService.setReactionDisplay(cards[j])
            }
           }
           this.sweetSucees(this.translate.instant('gameLabel.Section_removed'));   
        } )
      }
      // if(deletedSectionId !== -1){
      //   this.boardService.section.splice(deletedSectionId,1);
      //   this.sweetSucees(this.translate.instant('gameLabel.Section_removed'));
      //   alert("Remove section")
      // }
      }
    });
    // this.refCount++;
  // }

  this.boardService.sectionCopy=[...this.boardService.section]
  this.boardIconflag=true;
    this.commonService.homeFlag=true;
  this.commonService.analyticalBoardClick=false;
  this.commonService.boardFlag=false
  this.activeClassHome="activeIcon";
  this.activeClassAanlytical="";
  this.activeBoardIcon=""
  this.resetFilter();
//  this.renderer.setProperty(document.getElementById('mainDiv'), 'scrollTop', 0);  

}
analyticalBoardClick(){
  this.commonService.homeFlag=false;
  this.commonService.analyticalBoardClick=true;
  this.commonService.boardFlag=false
  this.activeClassHome="";
  this.activeClassAanlytical="activeIcon";
  this.activeBoardIcon=""
  this.sectionHeaderClass=''
//  this.renderer.setProperty(document.getElementById('mainDiv'), 'scrollTop', 0);  

}

boardClick(){
  this.goBoardHt=''
  this.boardService.currentSelectedBoard=''
  this.leftBarHideClass='content-page-without-sidebar';
  this.boardService.activeBoardBagImage='assets/images/Board/background-img.svg'
  this.boardService.scrollClass="boardScroll";
  this.renderer.removeClass(document.body, 'dynamic-body-class');
  this.refrence.off('child_changed', this.fireBaseChildChanged);
  this.refrence.off('child_added', this.fireBaseChildAdded);
  this.refrence.off('child_removed', this.fireBaseChildRemove);  
  this.boardIconflag=false;
  this.commonService.boardFlag=true;
  this.commonService.homeFlag=false;
  this.commonService.analyticalBoardClick=false;
  this.expandFilterFlag=false;
this.activeBoardIcon="activeIcon"
this.activeClassHome="";
  this.activeClassAanlytical="";
  this.boardService.getAllBoardData(this.commonService.userId).subscribe(
    res=>{
      this.allBoard=[...res.Result];
    })
    
    // this.renderer.setProperty(document.getElementById('mainDiv'), 'scrollTop', 0);  

}
emptyAllFields(){
  this.sectionName=''
  this.sectionDesc='';
  this.imageArr=[];
  this.fileArr=[];
  this.videoArr=[];
  this.cardName="";
  this.cardDesc="";
  this.url='';
  this.boardName="";
  this.boardDescription="";
  this.boardEditTitle="";
  this.boardEditDesc="";
  this.clearRichDescEditors();
  this.uploadedFileArray=[];
  this.cardEditTitle="";
  this.cardEditDesc="";
  this.sectionEditTitle="";
  this.editSectionDesc="";
  this.isRecording=false;
  this.blobUrl='';
  this.recordedTime=0
  this.imageVideo=[];
  this.audio=[];
  this.file=[];
  this.boardService.imageCount=0;
  this.boardService.videoCount=0;
  this.boardService.fileCount=0;
  this.boardService.audioCount=0;
  this.cardEditFlag=false;
  this.selectedImageIndex=5
  this.sectionMediaTab = 'image';
  this.cardMediaTab = 'image';
  if (this.audioPlayer && this.audioPlayer.nativeElement) {
    const audioPlayer = this.audioPlayer.nativeElement;
    audioPlayer.pause();
    audioPlayer.src = ''; 
    audioPlayer.currentTime = 0;
  }
  

}

selectedBoard(bId:any,board)
{
  this.goBoardHt="classForHT"
  this.boardService.currentSelectedBoard=board;
  this.commonService.loaderFlag=true;
  this.boardService.section =[];
  this.boardService.getBoardById(bId).subscribe(
    res=>{
      if(res===false){
        this.commonService.loaderFlag=false;
        let index = this.allBoard.findIndex(board => board.board_id === bId);   
        if(index!=-1){
          this.allBoard.splice(index,1)
          this.sweetInfo(this.translate.instant('gameLabel.Board_delete'))
        }
      }
      else{
      this.boardService.sectionData=res
      this.boardService.boardInnerPersmissions(this.boardService.sectionData.users_visiblity, this.boardService.sectionData)
      this.boardService.activeBoardUserName=res.user_info.name
      this.boardService.boardType=res.type;
      if(res.type==='assignment'){
       this.boardService.assignmentName=res.user_info.class_info.assignment_name
      }
      this.boardService.activeBoardName=res.name
      this.boardService.activeBoardDesc=this.getBoardDescText(res);
      this.boardService.assignmentId=res.assignment_id;
          this.boardService.activeBoardDate=res.created_date
          this.boardService.activeBoardId=res.board_id
          this.boardService.activeBoardBagImage='assets/images/Board-bag/demo'+ res.back_image+'.svg'
          this.boardService.section=res.sections;
          this.afterFilterList=JSON.parse((JSON.stringify([...this.boardService.section])))
          if(this.boardService.section.length>0){
        this.boardService.section.forEach((section=>{
          section.cards.forEach(card=>{
            this.boardService.setReactionDisplay(card);
            this.boardService.fillReactionBag(card);
            this.boardService.sectionCopy=[...this.boardService.section]
            this.boardService.currentSelectedSection=this.boardService.section[0];
            this.boardService.currentSelectedSection.cards=this.boardService.section[0].cards;
          })
        })
        )}
        if(this.commonService.cardId!==0){
          this.boardService.setAddedSectionFirst();
        }
        this.commonService.loaderFlag=false;
      this.homeClick();
      }
    })

}

// getVal(index) {
//   this.mostCommntedCardFilter=false;
//   let id=this.boardService.cardOwnerListDummy[index].id
//   this.selectedName=this.boardService.cardOwnerListDummy[index].username
//   if(id>0){
//     this.boardService.section = JSON.parse((JSON.stringify([...this.boardService.sectionCopy])))
//     this.boardService.section.forEach((section)=>{
//       section.cards = section.cards.filter((card)=>card.user_info['username'] === this.selectedName
//     )
//     })
//   }
//   else if(id===-1){
//     this.boardService.section = [...this.boardService.sectionCopy];
//     this.boardService.section.forEach((section) => {
//       if (section.cards && Array.isArray(section.cards)) {
//         section.cards.sort((a, b) => (b.cardComment.length || 0) - (a.cardComment.length || 0));
//       }
//     });
//   }
//   else{
//     this.boardService.section = [...this.boardService.sectionCopy];
//   }
//   this.afterFilterList=JSON.parse((JSON.stringify([...this.boardService.section])))
// }

viewSection(section:Section){
  this.sectionEditFlag=false;
  this.openModal('viewSection')
  this.sectionView=section
  this.editSectionProfile=section.user_info['avatar']
  this.getMediaCountForValidation(this.sectionView.media)
  this.colourPickerService.selctedColor=section.sectionColour;
}

expandSection(section: any, index?: number): void {
  this.expandedSection = section;
  this.expandSectionCardOpen = false;
  const sectionIndex = typeof index === 'number'
    ? index
    : this.boardService.section.findIndex((item) => item.sectionId === section.sectionId);
  if (sectionIndex >= 0) {
    this.getsectionId(section.sectionId, sectionIndex);
  }
  this.openModal('expandSection');
}

closeExpandSection(): void {
  this.expandSectionCardOpen = false;
  this.expandedSection = null;
  this.closeModal('expandSection');
}

closeExpandSectionCard(): void {
  this.expandSectionCardOpen = false;
}

updateSection(section){
  this.openModal('viewSection')
  this.sectionView=section
  this.editSectionProfile=section.user_info['avatar']
  this.getMediaCountForValidation(this.sectionView.media)
  this.sectionEditFlag=true
  this.sectionEditTitle=this.commonService.removeHTMLTags(this.sectionView.sectionName || '');
  this.editSectionDesc=this.sectionView.sectionDesc;
  this.colourPickerService.selctedColor=section.sectionColour
  this.uploadedFileArray=JSON.parse((JSON.stringify([...(this.sectionView.media || [])]))).map((media) => ({
    ...media,
    displayUrl: media.displayUrl || media.url
  }));
  setTimeout(() => {
    if (this.sectionEditDescEditor?.nativeElement) {
      this.sectionEditDescEditor.nativeElement.innerHTML = this.editSectionDesc || '';
    }
  });
}

getMediaCountForValidation(media){
  this.boardService.imageCount=0;
  this.boardService.videoCount=0;
  this.boardService.fileCount=0;
  this.boardService.audioCount=0;

  (media || []).forEach(item=>{
    if(item.type==='image' || item.type==='webimage'){
      this.boardService.imageCount=this.boardService.imageCount+1
    }
    else  if(item.type==='video' || item.type==='webvideo'){
      this.boardService.videoCount=this.boardService.videoCount+1
    }
    else  if(item.type==='file'){
      this.boardService.fileCount=this.boardService.fileCount+1
    }
    else  if(item.type==='audio'){
      this.boardService.audioCount=this.boardService.audioCount+1
    }
  })

}

editSection(){
  this.sectionEditFlag=true;
  this.sectionEditTitle=this.commonService.removeHTMLTags(this.sectionView.sectionName || '');
  this.editSectionDesc=this.sectionView.sectionDesc;
  this.uploadedFileArray=JSON.parse((JSON.stringify([...(this.sectionView.media || [])]))).map((media) => ({
    ...media,
    displayUrl: media.displayUrl || media.url
  }));
  this.getMediaCountForValidation(this.sectionView.media)
  setTimeout(() => {
    if (this.sectionEditDescEditor?.nativeElement) {
      this.sectionEditDescEditor.nativeElement.innerHTML = this.editSectionDesc || '';
    }
  });
}

updateOldSection(sectionId){
  this.getMediaData('Section').then(() => {
     let media=this.commonService.createMediaArray(this.uploadedFileArray) 
    this.uploadedFileArray.forEach((m)=>{
      if(m.hasOwnProperty('edit') && m.edit){let dummy: Media = {type: m.type, url: m.url, name:m.name ,isPlaying:false }; media.push(dummy) }
    })
     let sectionUpdate={
       name:this.sectionEditTitle,
       desc:this.editSectionDesc,
       sectionId:sectionId,
       media:media,
       color:this.colourPickerService.selctedColor,
       sectionColour:this.colourPickerService.selctedColor
     }
      this.boardService.updateSection(sectionUpdate).subscribe(
     res=>{
       const sectionIndex = this.boardService.section.findIndex(section => section.sectionId === sectionId);
       if (sectionIndex !== -1) {
        let cards=this.boardService.section[sectionIndex].cards
         this.boardService.section[sectionIndex] = this.withSectionColor(res, this.colourPickerService.selctedColor); 
         this.boardService.section[sectionIndex].cards=cards
         this.sectionView =  this.boardService.section[sectionIndex];
 }
       this.emptyAllFields();
       this.sectionEditFlag=false;
       this.closeModal('viewSection');
      //  this.translate.get('gameLabel.Section_update', { sectionName:newSection.sectionName }).subscribe(
      //   (str) => {
      //     this.msgString = str;
      //     this.sweetSucees( this.msgString);
          // alert("Section update+"+sectionId)
        // })
      
     })
   })
}


viewCard(card:Card,sectionName){
  this.cardEditFlag=false;
  this.boardService.viewCardSectionName=sectionName;
  this.cardView=card
  this.viewCardProfile=card.user_info['avatar']
  this.viewCardUserId=card.user_info['id'];
  if (this.expandedSection) {
    this.expandSectionCardOpen = true;
    return;
  }
  this.openModal('viewCard')
}

onCardSurfaceClick(event: MouseEvent, card: Card, sectionName: string): void {
  if (!this.boardService.cardView) {
    return;
  }
  const selection = window.getSelection();
  if (selection && selection.toString().trim()) {
    return;
  }
  const target = event.target as HTMLElement | null;
  if (!target) {
    return;
  }
  const interactiveSelector = [
    'a',
    'button',
    'input',
    'textarea',
    'select',
    'iframe',
    'audio',
    'video',
    'ngb-rating',
    '[ngbDropdown]',
    '.comment-box',
    '.emotions-icon-containetr',
    '.second-popop-emotion',
    '.sdg-logo-container',
    '.card-media-container',
    '.social-media-container',
    '.inner-card-comments',
    '.dropdown-menu'
  ].join(', ');
  if (target.closest(interactiveSelector)) {
    return;
  }
  this.viewCard(card, sectionName);
}

private populateCardEdit(): void {
  this.cardEditFlag = true;
  this.cardEditTitle = this.commonService.removeHTMLTags(this.cardView.cardTitle || '');
  this.cardEditDesc = this.cardView.cardDesc || '';
  this.selectedSectionName = this.commonService.removeHTMLTags(
    this.boardService.viewCardSectionName || ''
  );
  this.uploadedFileArray = JSON.parse(JSON.stringify([...(this.cardView.media || [])])).map((media) => ({
    ...media,
    displayUrl: media.displayUrl || media.url
  }));
  this.getMediaCountForValidation(this.uploadedFileArray);
  setTimeout(() => {
    if (this.cardEditDescEditor?.nativeElement) {
      this.cardEditDescEditor.nativeElement.innerHTML = this.cardEditDesc;
    }
  });
}

editCard(){
  this.closeModal('viewCard');
  this.populateCardEdit();
  setTimeout(() => this.openModal('editCard'), 200);
}

editCardDir(card:Card,sectionName){
  this.cardView=card
  this.boardService.viewCardSectionName=sectionName;
  this.viewCardProfile=card.user_info['avatar']
  this.viewCardUserId=card.user_info['id'];
  this.populateCardEdit();
  this.openModal('editCard');
}
cancelMedia(id,type,index){
   this.uploadedFileArray.pop(id);
   if(type==='csv' ||type==='pdf'|| type==='xlsx'){
    this.file.splice(index,1)
    this.boardService.fileCount= this.boardService.fileCount-1
   }
   else if(type==='audio'){
    this.audio.splice(index,1)
    this.boardService.audioCount= this.boardService.audioCount-1
   }
   else{
    if(type==='image'|| type==='webimage'){
      this.boardService.imageCount= this.boardService.imageCount-1
    }
    else if(type==='video'|| type==='webvideo'){
      this.boardService.videoCount= this.boardService.videoCount-1
    }
    this.imageVideo.splice(index,1)

   }


}

cancelMediaEdit(id,type){
  this.uploadedFileArray.splice(id,1);
  if(type==='csv' ||type==='pdf'|| type==='xlsx'){
    this.boardService.fileCount= 0
   }
   else if(type==='audio'){
    this.boardService.audioCount=0
   }
   else{
    if(type==='image'|| type==='webimage'){
      this.boardService.imageCount= 0
    }
    else if(type==='video'|| type==='webvideo'){
      this.boardService.videoCount= 0
    }
}
}

cancelEdit(){
  this.emptyAllFields();
  this.cardEditFlag=false
  this.sectionEditFlag=false;
  this.closeModal('editCard');
}

cancelSectionEdit(closeModal = false){
  this.emptyAllFields();
  this.sectionEditFlag = false;
  if (this.sectionView?.sectionColour) {
    this.colourPickerService.selctedColor = this.sectionView.sectionColour;
  }
  if (closeModal) {
    this.closeModal('viewSection');
  }
}

onSectionEditDescInput(event: Event): void {
  this.editSectionDesc = (event.target as HTMLElement).innerHTML;
}

updateOldCard(cardId){
  this.getMediaData('Card').then(() => {
    let media=this.commonService.createMediaArray(this.uploadedFileArray) 
   this.uploadedFileArray.forEach((m)=>{
     if(m.hasOwnProperty('edit') && m.edit){
      let dummy: Media = {
        type: m.type,
        url: m.url,
        name:m.name,
        isPlaying:false
      };
    media.push(dummy)   
    }
   })
    let cardUpdate={
      name:this.cardEditTitle,
      desc:this.cardEditDesc,
      cardId:cardId,
      media:media
    }
     this.boardService.updateCard(cardUpdate).subscribe(
    res=>{
      let newCard=res;
      const sectionIndex = this.boardService.section.findIndex(section => section.sectionId === this.cardView.sectionId);
      if (sectionIndex !== -1) {
        const cardIndex = this.boardService.section[sectionIndex].cards.findIndex(card => card.cardId === this.cardView.cardId);
        if (cardIndex !== -1) {
        const updatedSection = { ...this.boardService.section[sectionIndex] };
        updatedSection.cards[cardIndex] = newCard; 
        this.boardService.section[sectionIndex] = updatedSection; 
        this.cardView = newCard;
    }
}
      this.emptyAllFields();
      this.cardEditFlag=false;
      this.closeModal('editCard');
      // this.translate.get('gameLabel.card_update', {cardName:this.cardView.cardTitle }).subscribe(
      //   (str) => {
      //     this.msgString = str;
      //     this.sweetSucees( this.msgString);
          // alert("card update+"+changes.changeKey)
        // })
     
    })
  })
}

async updateMedia(type): Promise<void> {
  for (let i = 0; i < this.uploadedFileArray.length; i++) {
    try {
      if(this.uploadedFileArray[i].hasOwnProperty('edit')){
      const res = await this.boardService.getValidUrlForMediaStorage().toPromise();
      this.uploadedFileArray[i].url = await uploadFile(this.uploadedFileArray[i].actualFile, res);
    }
    } catch (error) {
      console.error('Error uploading file:', error);
    }
  }
}



check() {
  if (this.mostCommntedCardFilter) {
    this.boardService.section.forEach((section) => {
      if (section.cards && Array.isArray(section.cards)) {
        section.cards.sort((a, b) => (b.cardComment.length || 0) - (a.cardComment.length || 0));
        section.cards.reverse()
      }
    });
  } 
  else{
    // Deep cloning
    this.boardService.section=JSON.parse((JSON.stringify([...this.afterFilterList])));

  }

}

nextEvent() {
  this.selectLightboxMedia(this.getSelectedMediaIndex() + 1, 'next');
}

previousEvent() {
  this.selectLightboxMedia(this.getSelectedMediaIndex() - 1, 'prev');
}

private pauseLightboxPlayers(): void {
  const audio = this.audioPlayerRef?.nativeElement;
  if (audio) {
    audio.pause();
  }
  const video = this.videoPlayerRef?.nativeElement;
  if (video) {
    video.pause();
  }
}

private loadLightboxPlayer(media: any): void {
  if (!media) {
    return;
  }
  setTimeout(() => {
    if (media.type === 'audio') {
      this.updateAudioPlayer(media.url);
    } else if (media.type === 'video' && this.videoPlayerRef?.nativeElement) {
      const videoElement = this.videoPlayerRef.nativeElement;
      videoElement.src = media.url;
      videoElement.load();
    }
  }, 0);
}

private updateLightboxArrows(index: number): void {
  const last = (this.boardService.selectedMedia || []).length - 1;
  this.cssForDisableArrowsPre = index <= 0 ? 'disabled' : '';
  this.cssForDisableArrowsNext = index >= last ? 'disabled' : '';
}

private selectLightboxMedia(index: number, direction?: 'next' | 'prev'): void {
  const list = this.boardService.selectedMedia || [];
  if (!list.length || index < 0 || index >= list.length) {
    this.updateLightboxArrows(Math.max(0, Math.min(index, list.length - 1)));
    return;
  }
  this.pauseLightboxPlayers();
  this.boardService.curretnSelectedMedia = list[index];
  this.updateLightboxArrows(index);
  if (direction === 'next') {
    this.state = this.state === 'nextevent' ? 'nextevent2' : 'nextevent';
  } else if (direction === 'prev') {
    this.state = this.state === 'prevevent' ? 'prevevent2' : 'prevevent';
  }
  this.loadLightboxPlayer(list[index]);
}

startRecording() {
  if(this.boardService.audioCount===0){
 this.openModal('audioRecording');
  if (!this.isRecording) {
    this.isRecording = true;
    this.audioRecordingService.startRecording();
  }
  }
  else{
    this.openModal('confirm1')
    this.msgText=(this.translate.instant('gameLabel.You_only_add_one_audio_for_each_card'))
  }
}

stopRecording() {
  this.closeModal('audioRecording');
  if (this.isRecording) {
    this.audioRecordingService.stopRecording();
    this.isRecording = false;
    this.audioLevels = this.audioLevels.map(() => 0);
  }
}

clearRecordedData() {
  this.blobUrl = null;
  this.recordedTime=0
  if (this.isRecording) {
    this.isRecording = false;
    this.audioRecordingService.abortRecording();
  }
  this.audioLevels = this.audioLevels.map(() => 0);
  this.closeModal('audioRecording')
}

waveBarHeight(level: number): number {
  const min = 4;
  const max = 36;
  if (!level || level < 0.05) {
    return min;
  }
  return Math.round(min + Math.min(1, level) * (max - min));
}

trackWaveBar(index: number): number {
  return index;
}

deleteBoardConfirm(boardId,type){
  this.deleteBoardFlag=true;
  this.deleteSectionFlag=false;
  this.deleteCardFlag=false;
  this.deleteConfiremText=this.translate.instant('gameLabel.delete_board_warr')
  this.showYesNoModal(this.deleteConfiremText);
  this.deletedBoardId=boardId;
  this.deletedBoardType=type;
}

deleteBoard(){
   this.boardService.deleteBoard(this.deletedBoardId,this.deletedBoardType).subscribe(
    res=>{
      if(res===true){
        this.allBoard = this.allBoard.filter(board => board.board_id !== this.deletedBoardId);
        this.deletedBoardId="";
        this.sweetSucees(this.translate.instant('gameLabel.Board_deleted_succesfully'))
        this.deleteBoardFlag=false;
        this.deleteSectionFlag=false;
        this.deleteCardFlag=false; 
       this.deleteCommentFlag=false 
       this.goToGameFlag=false;
    }
  })
}

deleteSectionConfirm(sectionId){
  this.deleteBoardFlag=false;
  this.deleteSectionFlag=true;
  this.deleteCardFlag=false;
  this.deleteConfiremText=this.translate.instant('gameLabel.delete_section_warr')
  this.showYesNoModal(this.deleteConfiremText);
  this.deletedSectionId=sectionId;  
}

deleteSection(){
  this.boardService.deleteSection(this.deletedSectionId,'',this.boardService.activeBoardId).subscribe(
    res=>{
      if(res===true){
        this.deleteBoardFlag=false;
        this.deleteSectionFlag=false;
        this.deleteCardFlag=false; 
       this.deleteCommentFlag=false ;
       this.goToGameFlag=false;
        this.deletedSectionId=0
        this.closeModal('viewSection')
        this.boardService.getBoardById(this.boardService.activeBoardId).subscribe(
          res=>{
            let deletedSection= this.boardService.section.findIndex(section=>section.sectionId===this.deletedSectionId)
            if(deletedSection===-1){
             this.boardService.section=res.sections
             for(let i=0;i<res.sections.length;i++){
              let cards=res.sections[i].cards;
              for(let j=0;j<cards.length;j++){
                this.boardService.setReactionDisplay(cards[j])
              }
            }
             this.sweetSucees(this.translate.instant('gameLabel.Section_removed'));
             
            }
          })
          
        // this.boardService.section = this.boardService.section.filter(section => section.sectionId !== sectionId);
    }
  })
}

deleteCardConfirm(cardId,sectionId){
  this.deleteBoardFlag=false;
  this.deleteSectionFlag=false;
  this.deleteCardFlag=true;
  this.deleteConfiremText=this.translate.instant('gameLabel.delete_card_warr')
  this.showYesNoModal(this.deleteConfiremText);
  this.deleteTedCardId=cardId;
  this.deletedSectionId=sectionId
}


deleteCard(){
  this.boardService.deleteCard(this.deleteTedCardId,this.deletedSectionId,this.boardService.activeBoardId,true,'').subscribe(
    res=>{
      let sectionToUpdate = this.boardService.section.find(section => section.sectionId === this.deletedSectionId);
      if (sectionToUpdate) {
        sectionToUpdate.cards= res.Result;
        let text=this.commonService.removeHTMLTags(sectionToUpdate.sectionName+res.Result.cardTitle)
      this.sweetSucees(this.translate.instant('gameLabel.Card_removed'))
      }
      this.deleteBoardFlag=false;
      this.deleteSectionFlag=false;
      this.deleteCardFlag=false; 
     this.deleteCommentFlag=false 
     this.goToGameFlag=false;
      this.deleteTedCardId=0
      this.deletedSectionId=0
      this.expandSectionCardOpen = false;
      this.closeModal('viewCard');
      this.closeModal('editCard');
})
}

logOut(){
  this.showYesNoModal(this.translate.instant('gameLabel.logOutText'));
}

logOutYes(){
  localStorage.removeItem('token');
  window.location.href = this.commonService.logOutUrl;

}


saveComment(cardComment,cardId,commentCount,sectionId){

let comment={
   id: new Date(),
   text:cardComment,
   name:this.commonService.name,
   avatar:this.commonService.user.avatar,
   user_id:this.commonService.userId
}
if(cardComment!==''){
this.boardService.saveCommemt(comment,cardId,commentCount).subscribe(
  res=>{
    const sectionToUpdate = this.boardService.section.find( newSection =>newSection.sectionId === sectionId);
    if(sectionToUpdate){
     const updatedCard= sectionToUpdate.cards.find(card=>card.cardId===cardId);
     if(updatedCard){
      if (!Array.isArray(updatedCard.cardComment)) {
        updatedCard.cardComment = [];
      }
      updatedCard.commentText="";
      const commentId =updatedCard.cardComment.findIndex(existing=>existing.id===res.id)
      if(commentId===-1){
      updatedCard.cardComment.unshift(res);
      this.boardService.fillReactionBag(updatedCard);
      this.sweetSucees(this.translate.instant('gameLabel.add_comment'));
      }
     }
    } 
      this.boardService.editedCardId=0;
      this.boardService.addCommmentText=''
      this.boardService.sectionCopy=[...this.boardService.section]
      this.cdr.detectChanges();
  })
}
}


editClick(comment){
  this.boardService.editedCommentId=comment.id;
  comment.editCommentFlag=true;
  this.editCommentFlag=true;
  this.editCommentObj=comment;
  this.editCommentId=comment.id;
  this.editCommentText=comment.text

}
editComment(cardId,sectionId){
  let comment={
     id: this.editCommentObj.id,
     text:this.editCommentText,
  }
  let updatedid=comment.id;
  this.boardService.updateCommemt(cardId,comment).subscribe(
    res=>{
      const sectionToUpdate = this.boardService.section.find( newSection =>newSection.sectionId === sectionId);
      if(sectionToUpdate){
       const updatedCard= sectionToUpdate.cards.find(card=>card.cardId===cardId);
       if(updatedCard){
        const updatedComment= updatedCard.cardComment.find(comment=>comment.id===updatedid);
       if(updatedComment){
        updatedComment.editCommentFlag=false;
        updatedComment.text=res.text;
        this.sweetSucees(this.translate.instant('gameLabel.update_comment'));
        this.boardService.editedCommentId=0
       }
      }
      } 
      this.editCommentFlag=false
      this.editCommentText="";

    })
  }
  
cancelEditComment(comment){
   comment.editCommentFlag=false;
   this.editCommentText=""
  }

  deleteCommentConfirm(cardId,commentId,sectionId){
    this.deleteCommentFlag=true;
    this.showYesNoModal(this.translate.instant('gameLabel.delete_comment'));
    this.deleteCommentCardId=cardId;
    this.deleteCommentSectionId=sectionId;
    this.deleteCommentId=commentId;
  }


deleteComment(){
  this.boardService.deleteComment(this.deleteCommentCardId,this.deleteCommentId).subscribe(
    res=>{
    if(res){
      const sectionToUpdate = this.boardService.section.find( newSection =>newSection.sectionId === this.deleteCommentSectionId);
      if(sectionToUpdate){
       const updatedCard= sectionToUpdate.cards.find(card=>card.cardId===this.deleteCommentCardId);
       updatedCard.commentText="";
       if(updatedCard){
        const updatedComment= updatedCard.cardComment.findIndex(comment=>comment.id===this.deleteCommentId);
        if(updatedComment!==-1){
          updatedCard.cardComment.splice(updatedComment,1)
          this.sweetSucees(this.translate.instant('gameLabel.delete_comment_new'));
          this.deleteBoardFlag=false;
          this.deleteSectionFlag=false;
          this.deleteCardFlag=false; 
         this.deleteCommentFlag=false 
         this.goToGameFlag=false;
              }
      }
      } 
    }
    })
}

searchWeb() {
  if (this.searchWeb) {
    this.searchService.searchImages(this.search).subscribe(data => {
      this.imagesSerach = data.items;
    }, error => {
      console.error('Error fetching image search results', error);
    });

    this.searchService.searchVideos(this.search).subscribe(data => {
      this.videosSearch = data.items;
    }, error => {
      console.error('Error fetching video search results', error);
    });
  }
}

selectVideo(video: any) {
  this.searchSelectedVideos=video;
}


imageTab(){
this.imageActive="active";
this.imageSearchFlag=true;
this.videoSearchFlag=false;
this.videoActive="";
}

videoTab(){
  this.imageActive="";
  this.imageSearchFlag=false;
  this.videoSearchFlag=true;
  this.videoActive="active";
}

clearSearch(){
  this.imageTab();
  this.search="";
  this.searchSelectedImages=null;
  this.searchSelectedVideos=null;
  this.imagesSerach=[];
  this.videosSearch=[];
}
isSelectedImage(image: any): boolean {
  return this.searchSelectedImages === image;
}
isSelectedVideo(video: any): boolean {
  return this.searchSelectedVideos === video;
}

saveWebSearchVideo(){
  if(this.sectionEditFlag || this.cardEditFlag){
    if(this.searchSelectedImages!==null && this.boardService.imageCount===0){
      this.uploadedFileArray.push({name:this.searchSelectedImages['title'],type:'webimage',url:'',size:'',displayUrl:this.searchSelectedImages['link'],edit:true})
    }
    else if(this.boardService.imageCount>0  &&this.searchSelectedVideos===null){
      this.searchSelectedImages=null
      this.openModal('confirm1');
      this.msgText=this.translate.instant('gameLabel.You_only_add_one_image_media_at_one_section');
    }
    if(this.searchSelectedVideos!==null  && this.boardService.videoCount===0){
      this.uploadedFileArray.push({name:this.searchSelectedVideos['title'],type:'webvideo',url:'',size:'',displayUrl:this.searchSelectedVideos['id'].videoId,edit:true})
    }
    else  if(this.boardService.videoCount>0 &&this.searchSelectedImages===null ){
      this.searchSelectedVideos=null
      this.openModal('confirm1');
      this.msgText=this.translate.instant('gameLabel.You_only_add_one_image_media_at_one_section');
    }
  }
  else{
    if(this.searchSelectedImages!==null  && this.boardService.imageCount===0){
      this.uploadedFileArray.push({name:this.searchSelectedImages['title'],type:'webimage',url:'',size:'',displayUrl:this.searchSelectedImages['link'],edit:false})
      this.createInnerArrayforMedia('webimage',this.searchSelectedImages['link'],this.uploadedFileArray.length-1)
  
    }
    else  if(this.boardService.imageCount>0 &&this.searchSelectedVideos===null){
      this.openModal('confirm1');
      this.searchSelectedImages=null
      this.msgText=this.translate.instant('gameLabel.You_only_add_one_image_media_at_one_section');
    }

    if(this.searchSelectedVideos!==null  && this.boardService.videoCount===0){
      this.uploadedFileArray.push({name:this.searchSelectedVideos['title'],type:'webvideo',url:'',size:'',displayUrl:this.searchSelectedVideos['id'].videoId,edit:false})
      this.createInnerArrayforMedia('webvideo',this.searchSelectedVideos['id'].videoId,this.uploadedFileArray.length-1)
    }
    else  if(this.boardService.videoCount>0&&this.searchSelectedImages===null ){
      this.openModal('confirm1');
      this.searchSelectedVideos=null
      this.msgText=this.translate.instant('gameLabel.You_only_add_one_image_media_at_one_section');

    }
   
  }
  this.clearSearch();
  this.closeModal('webSearch')
  
}

clickFilter(){
  this.commonService.loaderFlag=true
  this.expandFilterFlag=!this.expandFilterFlag;
  this.boardService.getBoardActiveUseList(this.boardService.activeBoardId).subscribe(
    res=>{
      // res.unshift({'id':-1,'username':this.translate.instant('gameLabel.Most_commentd_card')});
      // res.unshift({'id':0,'username':this.translate.instant('gameLabel.Select_All')});
      this.boardService.cardOwnerListDummy=res;
      this.commonService.loaderFlag=false
    }
  )
}


createInnerArrayforMedia(type,url,actualArrayIndex){
  if(type==='image' ||type==='video' ||type==='webimage'||type==='webvideo'){
    this.imageVideo.push({'type':type,'url':url,'realIndex':actualArrayIndex})
    if(type==='image' || type==='webimage'){
      this.boardService.imageCount=this.boardService.imageCount+1
    }
    else if(type==='video' || type==='webvideo'){
      this.boardService.videoCount=this.boardService.videoCount+1
    }
  }
  else if(type==='file'){
    this.file.push({'type':type,'url':url,'realIndex':actualArrayIndex})
    this.boardService.fileCount=this.boardService.fileCount+1

  }
  else if(type==='audio'){
    this.audio.push({'type':type,'url':url,'realIndex':actualArrayIndex})
    this.boardService.audioCount=this.boardService.audioCount+1

  }

}
openModal(modalId: string) {
  $(`#${modalId}`).modal('show');
}

private bindStackedModals(): void {
  $(document).on('show.bs.modal.rlStack', '.modal', (event) => {
    const $modal = $(event.target);
    const openCount = $('.modal.show').not($modal).length;
    if (!openCount) {
      return;
    }
    const zIndex = 1055 + (openCount * 20);
    $modal.css('z-index', zIndex);
    setTimeout(() => {
      $('.modal-backdrop').not('.modal-stack').last()
        .css('z-index', zIndex - 10)
        .addClass('modal-stack');
    }, 0);
  });
  $(document).on('hidden.bs.modal.rlStack', '.modal', (event) => {
    $(event.target).css('z-index', '');
    if ($('.modal.show').length) {
      document.body.classList.add('modal-open');
    }
  });
}

private unbindStackedModals(): void {
  $(document).off('.rlStack');
}

closeModal(modalId: string) {
  if (this.audioPlayerRef && this.audioPlayerRef.nativeElement) {
    const audioPlayer = this.audioPlayerRef.nativeElement;
    audioPlayer.pause();
    audioPlayer.src = ''; 
    audioPlayer.currentTime = 0;
  }
  this.resetLightboxAudioState();
  $(`#${modalId}`).modal('hide');
 
}

arroePress(){
  this.expandFlag=!this.expandFlag;
}
sendInvitation(){
    if (this.searchInviterUser.trim() === '') {
      this.searchFilteredUsers = [];
      return;
    }
    const lowerCaseSearchTerm = this.searchInviterUser.toLowerCase();
    const searchTerms = lowerCaseSearchTerm.split(' ').filter(term => term.trim() !== '');

    this.searchFilteredUsers = this.boardService.users.filter(user => {
      const userString = (user.username + ' ' + user.name + ' ' + user.email + ' ' + user.drole).toLowerCase();
      return searchTerms.every(term => userString.includes(term));
    });
}

toggleSelection(user: User) {
  const index = this.selectedUsers.findIndex(u => u.id === user.id);
  if (index > -1) {
    this.selectedUsers.splice(index, 1);
  } else {
    this.selectedUsers.push({ ...user, permissions: this.setUserPermission});
  }
}

isSelected(user: User): boolean {
  return this.selectedUsers.some(u => u.id === user.id);
}

getInvitePermission(user: User): string {
  const selected = this.selectedUsers.find(u => u.id === user.id);
  return selected?.permissions || user.permissions || this.setUserPermission || 'write';
}

deselectAll() {
  this.selectedUsers = [];
}

removeSelectedUser(user: User) {
  this.selectedUsers = this.selectedUsers.filter(u => u.id !== user.id);
  // this.searchFilteredUsers = this.searchFilteredUsers.filter(u => u.id !== user.id);
}

updateAdminAccess(user: User, event) {
  this.setUserPermission=event.target.value;
  const index = this.selectedUsers.findIndex(u => u.id === user.id);
  if (index > -1) {
    this.selectedUsers[index].permissions = this.setUserPermission;
  }
}

updateAdminAccessGamer(event) {
  this.gamerPermissions=event.target.value;
}
sendInvitationToList(emailString){
  let selectedUsers
  if(this.commonService.user.drole==='Gamer'){
    if(!emailString.includes(this.commonService.user.email)){
    if (emailString) {
      const emailList = emailString.split(',').map(email => email.trim()).filter(email => this.validateEmail(email));
      if (emailList.length > 0) {
        selectedUsers = emailList.map(email => ({ email, permission: this.gamerPermissions }));
  }
}
else{
  this.openModal('confirm1')
  this.msgText=(this.translate.instant('gameLabel.No_valid_email_addresses_found'))
}
    }
    else{
      this.openModal('confirm1')
      this.msgText=(this.translate.instant('gameLabel.You_can_not_add_your_own_email_address'))

    }
  }
  else{
     selectedUsers=this.selectedUsers;
  }
  this.boardService.sendInvitationToList(selectedUsers,this.commonService.user.drole,this.boardService.activeBoardId).subscribe(
    res=>{
      if(res){
    this.msgText=this.translate.instant('gameLabel.All_invitation_send_succesfully')
    this.closeModal('inviteUser')
    this.sweetSucees(this.msgText);
     this.closeInvitation();
      }
 })
}


closeInvitation(){
  this.selectedUsers=[];
  this.msgText="";
  this.searchInviterUser=""
  this.searchFilteredUsers=[];
}

onSubmit(form: NgForm) {
  if (form.valid) {
    const email = form.value.inviterUserEmail;
  }
} 

validateEmail(email: string): boolean {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
}

selectImage(index: number) {
  if (this.selectedImageIndex === index) {
    // this.selectedImageIndex = null;
    // this.boardBagImage="";
  } else {
    this.selectedImageIndex = index;
    this.boardBagImage="demo"+index;
  }
}
selectImageEdit(index: number) {
  if (this.editBoardBagId === index) {
    this.editBoardBagId = null;
    this.boardBagImage="";
  } else {
    this.editBoardBagId = index;
    this.boardBagImage="demo"+index;
  }
}
selectImageForWebSearch(image: any) {
  this.searchSelectedImages=image
}

getNotification(){
  if(this.boardService.allNotifications.length===0){
  this.boardService.getNotification(this.commonService.user.id).subscribe(
    res=>{
       this.boardService.allNotifications=res.Result
       this.boardService.notificationCount=res.Result.length;
    })
  }
}

updateNotification(type,notification){
  this.boardService.updateNotification(type,notification.board_id,notification.notification_id,notification.permissions).subscribe(
    res=>{
      if(res){
      const index = this.boardService.allNotifications.findIndex(notification => notification.notification_id === notification.notification_id);    
          if(type==='accept'){
            this.boardService.getAllBoardData(this.commonService.user.id).subscribe(
              res=>{
                if (index !== -1) {
                  this.boardService.allNotifications.splice(index, 1);
                  this.boardService.notificationCount=  this.boardService.notificationCount-1
                }
                this.allBoard=[...res.Result];
                this.closeModal('notification')
                let msg=this.translate.instant('gameLabel.board_Add')
                this.sweetSucees(msg);
                this.commonService.boardFlag=true;
                this.commonService.homeFlag=false;
              })
          }
          else if(type==='delete'){
            if (index !== -1) {
              this.boardService.allNotifications.splice(index, 1);
              this.boardService.notificationCount=  this.boardService.notificationCount-1
            }
            let msg=this.translate.instant('gameLabel.delete_noti')
            this.sweetSucees(msg);
          }
        }
        })
      
}

setReaction(selected: 'like' | 'love' | 'haha' | 'wow' | 'sad' | 'angry',card) {
  if (!Array.isArray(card.reactions)) {
    card.reactions = [];
  }
  const reaction = {
    user_id: this.commonService.user.id,
    type: selected,
    name: this.commonService.userName,
    avatar: this.commonService.user.avatar
  };
  const index = card.reactions.findIndex(r => r.user_id === this.commonService.user.id);
  if (index !== -1) {
    card.reactions.splice(index, 1);
  }
  card.reactions.push(reaction);

  this.selectedReaction = selected;
  card.showReaction = false;
  card.showReactionEdit = false;
  this.boardService.setReactionDisplay(card);
  this.boardService.fillReactionBag(card);
  this.syncCardReactions(card);
  this.cdr.detectChanges();

  this.boardService.updateReaction(card.reactions, card.cardId).subscribe(
    () => {
      this.selectedReaction = null;
      this.syncCardReactions(card);
    },
    err => {
      console.error('Failed to save reaction', err);
      this.msgText = this.translate.instant('gameLabel.error');
      this.openModal('confirm1');
    }
  );
}

private syncCardReactions(card) {
  const sectionIndex = this.boardService.section.findIndex(section => section.sectionId === card.sectionId);
  if (sectionIndex === -1) {
    return;
  }
  const selectedCard = this.boardService.section[sectionIndex].cards.find(c => c.cardId === card.cardId);
  if (selectedCard) {
    selectedCard.reactions = card.reactions;
    selectedCard.lastThreeReaction = card.lastThreeReaction;
    selectedCard.reactionCount = card.reactionCount;
    selectedCard.reactionIconClass = card.reactionIconClass;
    selectedCard.reactionBag = card.reactionBag;
  }
  this.boardService.sectionCopy = [...this.boardService.section];
}

removeReaction(){
  const card = this.reactionDeleteSelectedCard;
  if (!card || !Array.isArray(card['reactions'])) {
    return;
  }
  const index = card['reactions'].findIndex(reaction => reaction.user_id === this.commonService.user.id);
  if (index !== -1) {
    card['reactions'].splice(index, 1);
  }
  this.boardService.setReactionDisplay(card);
  this.boardService.fillReactionBag(card);
  this.syncCardReactions(card);
  this.cdr.detectChanges();

  this.boardService.removeReaction(card['cardId']).subscribe(
    res => {
      if (Array.isArray(res) && res.length > 0) {
        card['reactions'] = res;
        this.boardService.setReactionDisplay(card);
        this.boardService.fillReactionBag(card);
        this.syncCardReactions(card);
        this.reactionModel(res, card);
      } else {
        this.closeModal('reactionModel');
      }
    }
  );
}


clickReaction(card){
  card.showReaction=!card.showReaction;
}
clickReactionEdit(card){
  card.showReactionEdit=!card.showReactionEdit;
}

reactionModel(reactions,card){
  this.  reactionActiveTabIndex = 0;
  this.reactionDeleteSelectedCard=card;
  this.reactionTab=[];
  this.boardService.likeReactionArray=[]
  this.boardService.loveReactionArray=[]
  this.boardService.hahaReactionArray=[]
  this.boardService.wowReactionArray=[]
  this.boardService.sadReactionArray=[]
  this.boardService.angryReactionArray=[]
  reactions.forEach(reaction=>{
   if(reaction.type==='like'){
    this.boardService.likeReactionArray.push(reaction);

   }
   else if(reaction.type==='love'){
    this.boardService.loveReactionArray.push(reaction)

   }
   else if(reaction.type==='wow'){
    this.boardService.wowReactionArray.push(reaction)

   }
   else if(reaction.type==='haha'){
    this.boardService.hahaReactionArray.push(reaction)


   }
   else if(reaction.type==='sad'){
    this.boardService.sadReactionArray.push(reaction)


   }
   else if(reaction.type==='angry'){
    this.boardService.angryReactionArray.push(reaction)

   }
  })
  if(this.boardService.likeReactionArray.length>0){
    this.reactionTab.push({'img':'assets/images/Board/blue-like.png','count':this.boardService.likeReactionArray.length,'content':this.boardService.likeReactionArray,type:'like'})
  }
  if(this.boardService.loveReactionArray.length>0){
    this.reactionTab.push({ 'img':'assets/images/Board/red-love.png','count':this.boardService.loveReactionArray.length,'content':this.boardService.loveReactionArray,type:'love'})

  }
  if(this.boardService.hahaReactionArray.length>0){
    this.reactionTab.push({ 'img':'assets/images/Board/happy.png','count':this.boardService.hahaReactionArray.length,'content':this.boardService.hahaReactionArray,type:'haha'})

  }
  if(this.boardService.wowReactionArray.length>0){
    this.reactionTab.push({ 'img':'assets/images/Board/wow.png','count':this.boardService.wowReactionArray.length,'content':this.boardService.wowReactionArray,type:'wow'})

  }
  if(this.boardService.sadReactionArray.length>0){
    this.reactionTab.push({ 'img':'assets/images/Board/sad.png','count':this.boardService.sadReactionArray.length,'content':this.boardService.sadReactionArray,type:'sad'})

  }
  if(this.boardService.angryReactionArray.length>0){
    this.reactionTab.push({'title': 'Tab 5', 'img':'assets/images/Board/angry.png','count':this.boardService.angryReactionArray.length,'content':this.boardService.angryReactionArray,type:'angry'})
  }
}

selectTab(index: number): void {
  this.reactionActiveTabIndex = index;
}

setDefaultMedia(media,name,ownerName?){
  this.boardService.selectedMedia=[]
  this.boardService.currentMediaOwnerName = ownerName || '';
  if(media.length>0){
  this.boardService.selectedMedia=media;
  for(let i=0;i<media.length;i++){
    if (media[i].name === name) {
      this.boardService.curretnSelectedMedia = media[i];
      this.updateLightboxArrows(i);
      if (this.boardService.curretnSelectedMedia.type === 'audio') {
        this.updateAudioPlayer(this.boardService.curretnSelectedMedia.url);
        this.boardService.currentSlectedVideoURl=''
        break;
      }
      else if(this.boardService.curretnSelectedMedia.type === 'video'){
        if (this.videoPlayerRef && this.videoPlayerRef.nativeElement) {
          const videoElement = this.videoPlayerRef.nativeElement;
          videoElement.src = this.boardService.curretnSelectedMedia.url;
          videoElement.load(); 
          videoElement.play(); 
          break;
        }
      }
      break
    }
    }
    this.openModal('mediaView')
  }
  }


  private updateAudioPlayer(url: string): void {
    this.resetLightboxAudioState();
    if (this.audioPlayerRef && this.audioPlayerRef.nativeElement) {
      const audioPlayer = this.audioPlayerRef.nativeElement;
      audioPlayer.pause();
      audioPlayer.src = url || '';
      audioPlayer.volume = this.lightboxAudioVolume;
      audioPlayer.muted = this.lightboxAudioMuted;
      audioPlayer.load();
    }
  }

  get lightboxAudioProgress(): number {
    if (!this.lightboxAudioDuration) {
      return 0;
    }
    return Math.min(100, (this.lightboxAudioCurrent / this.lightboxAudioDuration) * 100);
  }

  formatLightboxTime(seconds: number): string {
    if (!isFinite(seconds) || seconds < 0) {
      return '0:00';
    }
    const total = Math.floor(seconds);
    const minutes = Math.floor(total / 60);
    const rest = total % 60;
    return `${minutes}:${rest.toString().padStart(2, '0')}`;
  }

  lightboxVolumeIcon(): string {
    if (this.lightboxAudioMuted || this.lightboxAudioVolume === 0) {
      return 'volume_off';
    }
    return this.lightboxAudioVolume < 0.5 ? 'volume_down' : 'volume_up';
  }

  toggleLightboxAudioPlay(): void {
    const audio = this.audioPlayerRef?.nativeElement;
    if (!audio) {
      return;
    }
    if (audio.paused) {
      audio.play().catch(() => {
        this.lightboxAudioPlaying = false;
      });
    } else {
      audio.pause();
    }
  }

  seekLightboxAudio(event: Event): void {
    const audio = this.audioPlayerRef?.nativeElement;
    const value = Number((event.target as HTMLInputElement).value);
    this.lightboxAudioCurrent = value;
    if (audio) {
      audio.currentTime = value;
    }
  }

  toggleLightboxMute(): void {
    const audio = this.audioPlayerRef?.nativeElement;
    this.lightboxAudioMuted = !this.lightboxAudioMuted;
    if (audio) {
      audio.muted = this.lightboxAudioMuted;
    }
  }

  setLightboxVolume(event: Event): void {
    const value = Number((event.target as HTMLInputElement).value);
    const audio = this.audioPlayerRef?.nativeElement;
    this.lightboxAudioVolume = value;
    this.lightboxAudioMuted = value === 0;
    if (audio) {
      audio.volume = value;
      audio.muted = this.lightboxAudioMuted;
    }
  }

  onLightboxAudioTime(): void {
    const audio = this.audioPlayerRef?.nativeElement;
    if (!audio) {
      return;
    }
    this.lightboxAudioCurrent = audio.currentTime || 0;
    if (audio.duration && isFinite(audio.duration)) {
      this.lightboxAudioDuration = audio.duration;
    }
  }

  onLightboxAudioMeta(): void {
    const audio = this.audioPlayerRef?.nativeElement;
    if (!audio) {
      return;
    }
    this.lightboxAudioDuration = isFinite(audio.duration) ? audio.duration : 0;
    audio.volume = this.lightboxAudioVolume;
    audio.muted = this.lightboxAudioMuted;
  }

  onLightboxAudioEnded(): void {
    this.lightboxAudioPlaying = false;
    this.lightboxAudioCurrent = 0;
    const audio = this.audioPlayerRef?.nativeElement;
    if (audio) {
      audio.currentTime = 0;
    }
  }

  onLightboxAudioPlay(): void {
    this.lightboxAudioPlaying = true;
  }

  onLightboxAudioPause(): void {
    this.lightboxAudioPlaying = false;
  }

  private resetLightboxAudioState(): void {
    this.lightboxAudioPlaying = false;
    this.lightboxAudioCurrent = 0;
    this.lightboxAudioDuration = 0;
  }



//   setMedia(media){
//     let newMedia=[]; 
//    this.boardService.selectedMedia=[]
//     if(media.length>0){
//     media.forEach(m=>{
//       newMedia.push({name:m.name,type:m.type,url:m.displayUrl})
//     })
//     this.boardService.selectedMedia=newMedia;
//     this.boardService.curretnSelectedMedia=newMedia[0]
//     this.openModal('mediaView')
//     }

// }

ngOnDestroy(): void {
  this.unbindStackedModals();
  this.refrence.off('child_changed', this.fireBaseChildChanged);
  this.refrence.off('child_added', this.fireBaseChildAdded);
  this.refrence.off('child_removed', this.fireBaseChildRemove);
  this.editorTitle.destroy();
  this.editorDesc.destroy();
  this.editorTitleSection.destroy();
  this.editorDescSection.destroy();
  this.editorTitleBoard.destroy();
  this.editorDescBoard .destroy();
  this.boardEditTitleEd.destroy();
  this.bordEditDescEd.destroy();
  this.sectionCreateTitle.destroy();
  this.sectionCreateDesc.destroy();
  this.addTitleCard.destroy();
  this.addDescCard.destroy();
    this.unsubscriber.next();
    this.unsubscriber.complete();
  }


setSelectedLang(code){
  this.translationService.setSelectedlanguage(code);

}
public toggleFullScreen(): void {
  const doc: any = window.document;
  const root: any = doc.documentElement;

  if (!doc.fullscreenElement && !doc.mozFullScreenElement && !doc.webkitFullscreenElement && !doc.msFullscreenElement) {
    if (root.requestFullscreen) {
      root.requestFullscreen();
    } else if (root.mozRequestFullScreen) {
      root.mozRequestFullScreen();
    } else if (root.webkitRequestFullscreen) {
      root.webkitRequestFullscreen();
    } else if (root.msRequestFullscreen) {
      root.msRequestFullscreen();
    }
  } else if (doc.exitFullscreen) {
    doc.exitFullscreen();
  } else if (doc.mozCancelFullScreen) {
    doc.mozCancelFullScreen();
  } else if (doc.webkitCancelFullScreen) {
    doc.webkitCancelFullScreen();
  } else if (doc.msExitFullscreen) {
    doc.msExitFullscreen();
  }
}

@HostListener('document:fullscreenchange')
@HostListener('document:webkitfullscreenchange')
@HostListener('document:mozfullscreenchange')
@HostListener('document:MSFullscreenChange')
onFullscreenChange(): void {
  const doc: any = window.document;
  this.isFullscreen = !!(doc.fullscreenElement || doc.webkitFullscreenElement || doc.mozFullScreenElement || doc.msFullscreenElement);
  if (this.isFullscreen) {
    doc.body.classList.add('fullscreen-enable');
    doc.body.setAttribute('data-toggle', 'fullscreen');
  } else {
    doc.body.classList.remove('fullscreen-enable');
    doc.body.removeAttribute('data-toggle');
  }
  this.cdr.markForCheck();
}

exitHandler(): void {
  this.onFullscreenChange();
}

/**
 * Fetches profile options
 */
_fetchProfileOptions(): void {
  this.profileOptions = [
    {
      label: this.translate.instant('gameLabel.My_Account'),
      icon: 'fe-user me-1',
    },
    {
      label: this.translate.instant('gameLabel.logOut'),
      icon: 'fe-log-out me-1',
    }
  ];

}

togglePlay(media): void {
  if (this.currentlyPlayingMedia && this.currentlyPlayingMedia !== media) {
    this.audioPlayer.nativeElement.pause();
    this.currentlyPlayingMedia.isPlaying = false;
  }
  if (media.isPlaying) {
    this.audioPlayer.nativeElement.pause();
    media.isPlaying = false;
    this.currentlyPlayingMedia = null;
  } else {
    this.audioPlayer.nativeElement.src = media.displayUrl;
    this.audioPlayer.nativeElement.play();
    media.isPlaying = true;
    this.currentlyPlayingMedia = media;
  }
}


sweetSucees(text) {
  this.rlToastService.success(text);
}

sweetAlert(text) {
  this.rlToastService.warning(text);
}


sweetInfo(text) {
  this.rlToastService.info(text);
}


sweetQue(text) {
  this.rlToastService.show(text, 'question');
}
showYesNoModal(text) {
  Swal.fire({
    title: text,
    icon: 'question',
    showCancelButton: true,
    reverseButtons: true,
    focusCancel: true,
    buttonsStyling: false,
    cancelButtonText: this.translate.instant('gameLabel.No'),
    confirmButtonText: this.translate.instant('gameLabel.Yes'),
    customClass: {
      popup: 'rl-swal',
      confirmButton: 'rl-swal-confirm',
      cancelButton: 'rl-swal-cancel',
      actions: 'rl-swal-actions',
    },
  }).then((result) => {
    if (result.isConfirmed) {
      if(!this.deleteBoardFlag && !this.deleteSectionFlag && !this.deleteCardFlag&&!this.deleteCommentFlag &&!this.goToGameFlag){
       this.logOutYes();
      }
      else if(this.deleteCommentFlag){
      this.deleteComment();
      }
      else if(this.deleteBoardFlag){
        this.deleteBoard();
      }
      else if(this.deleteSectionFlag){
        this.deleteSection();
      }
      else if(this.deleteCardFlag){
        this.deleteCard();
      }
      else if(this.goToGameFlag){
         this.checkParentWindow();
      }
    } 
    // else if (result.dismiss === Swal.DismissReason.cancel) {
    //   Swal.fire('Cancelled', 'You have cancelled the action.', 'error');
    // }
  });
}

setMediaCount(){
  this.boardService.imageCount=0;
  this.boardService.videoCount=0;
  this.boardService.audioCount=0;
  this.boardService.videoCount=0;

}



openwebSearch(){
  this.openModal('webSearch')
}

closeWebSerach(){
  this.closeModal('webSearch')
  this.searchSelectedImages=null;
  this.search='';
  this.imagesSerach=[];
  this.videosSearch=[];
  if (this.videoPlayerRef && this.videoPlayerRef.nativeElement) {
    const videoElement = this.videoPlayerRef.nativeElement;
    videoElement.pause(); // Pause the video
    videoElement.currentTime = 0; // Reset to the beginning
  }
}


clickThumbnail(url){
  this.commonService.loaderFlag=true
  this.thumbnailImage="";
this.thumbnailImage=url;
this.commonService.loaderFlag=false;
}

sdgView(sdg){
this.tagSdg=sdg;
}

viewAllComment(card:Card){
 this.cardComment=card;
let userInfo=card.user_info;
this.cardUserId=userInfo['id']
}

toggle(id): void {
  if(id===1){
this.toggleClassAssignment="activeBoard"
this.toggleClassPersonal="switch"
this.boardFilterType='assignment'
  }
else if(id===2){
  this.toggleClassPersonal="activeBoard"
  this.toggleClassAssignment="switch"
  this.boardFilterType='all';
}
}


getCardAuthorName(card: any): string {
  if (!card?.user_info) {
    return '';
  }
  if (card.user_info.name) {
    return card.user_info.name;
  }
  return [card.user_info.firstname, card.user_info.lastname].filter(Boolean).join(' ').trim();
}

getInitials(name: string): string {
  if (!name || !name.trim()) {
    return '';
  }
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].substring(0, 2).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

/** Plain board description text, or empty string when none was entered. */
getBoardDescText(board: any): string {
  return this.commonService.removeHTMLTags(board?.description || board?.desc || '')?.trim() || '';
}

getCardPreview(card: any): { kind: 'image' | 'video' | 'file'; url: string } | null {
  const thumbnail = card?.thumbnail?.[0]?.url;
  if (thumbnail) {
    return { kind: 'image', url: thumbnail };
  }

  const media = Array.isArray(card?.media) ? card.media : [];
  const image = media.find((item) => item?.type === 'image' || item?.type === 'webimage');
  if (image?.url) {
    return { kind: 'image', url: image.url };
  }

  const video = media.find((item) => item?.type === 'video');
  if (video?.url) {
    return { kind: 'video', url: video.url };
  }

  const fileIcons: Record<string, string> = {
    csv: 'assets/images/media/csv.svg',
    sheet: 'assets/images/media/excel.svg',
    ppt: 'assets/images/media/ppt.svg',
    pdf: 'assets/images/media/pdf.svg'
  };
  const file = media.find((item) => fileIcons[item?.type]);
  if (file) {
    return { kind: 'file', url: fileIcons[file.type] };
  }

  return null;
}

getSelectedMediaIndex(): number {
  const list = this.boardService.selectedMedia || [];
  const current = this.boardService.curretnSelectedMedia;
  if (!current || !list.length) {
    return 0;
  }
  const byRef = list.indexOf(current);
  if (byRef >= 0) {
    return byRef;
  }
  const byUrlAndName = list.findIndex((item) => item?.url === current.url && item?.name === current.name);
  if (byUrlAndName >= 0) {
    return byUrlAndName;
  }
  const byUrl = list.findIndex((item) => item?.url === current.url);
  return byUrl < 0 ? 0 : byUrl;
}

/** Plain section description text, or empty string when none was entered. */
getSectionDescText(section: any): string {
  return this.commonService.removeHTMLTags(section?.sectionDesc || '')?.trim() || '';
}

/** Plain card description text for the outer card preview. */
getCardDescText(card: any): string {
  const html = card?.cardDesc || '';
  return String(html)
    .replace(/<[^>]*>/g, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

getFirstName(name: string): string {
  if (!name || !name.trim()) {
    return '';
  }
  return name.trim().split(/\s+/)[0];
}

scrollToEnd() {
  if (this.isScrolling) return; // Prevent multiple scroll operations
  this.isScrolling = true;
  const scrollableDivElement = this.scrollableDiv.nativeElement;
  const scrollWidth = scrollableDivElement.scrollWidth;
  const scrollLeft = scrollableDivElement.scrollLeft;
  const scrollStep = (scrollWidth - scrollLeft) / 50; // Adjust the divisor for speed
  if (this.smoothScrollTimeout) {
    clearTimeout(this.smoothScrollTimeout);
  }
  setTimeout(() => {
    this.isScrolling = false;
    if (this.smoothScrollTimeout) {
      clearTimeout(this.smoothScrollTimeout);
    }
  }, 1000);

  this.smoothScroll(scrollableDivElement, scrollStep, scrollWidth);
}

resetScroll() {
  this.isScrolling = false;
  if (this.smoothScrollTimeout) {
    clearTimeout(this.smoothScrollTimeout);
  }
}

smoothScroll(element: HTMLElement, step: number, target: number) {
  if (element.scrollLeft < target && this.isScrolling) {
    element.scrollLeft += step;
    this.smoothScrollTimeout = setTimeout(() => this.smoothScroll(element, step, target), 10); // Adjust the delay for smoothness
  } else {
    this.isScrolling = false;
  }
}


selectSectionColor(color: string) {
  this.colourPickerService.selctedColor = color;
  this.color.setValue(color);
}

getSectionColor(section: any): string {
  const raw = (section?.sectionColour || section?.color || section?.section_colour || '').toString().trim();
  if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(raw)) {
    return raw;
  }
  if (/^[0-9a-fA-F]{6}$/.test(raw)) {
    return '#' + raw;
  }
  return this.sectionColorSwatches[7];
}

withSectionColor(section: any, fallbackColor: string) {
  const color = this.getSectionColor({ ...section, sectionColour: section?.sectionColour || fallbackColor });
  return { ...section, sectionColour: color, color };
}

scrollSectionsBy(delta: number) {
  if (!this.scrollableDiv?.nativeElement) {
    return;
  }
  this.scrollableDiv.nativeElement.scrollBy({ left: delta, behavior: 'smooth' });
}

scrollToStart() {
  if (this.isScrolling) return; // Prevent multiple scroll operations
  this.isScrolling = true;

  const scrollableDivElement = this.scrollableDiv.nativeElement;
  const scrollLeft = scrollableDivElement.scrollLeft;
  const scrollStep = scrollLeft / 50; // Adjust the divisor for speed

  if (this.smoothScrollTimeout) {
    clearTimeout(this.smoothScrollTimeout);
  }

  this.smoothScrollTimeout = setTimeout(() => {
    this.isScrolling = false;
    if (this.smoothScrollTimeout) {
      clearTimeout(this.smoothScrollTimeout);
    }
  }, 1000);

  this.smoothScrollToStart(scrollableDivElement, scrollStep);
}

smoothScrollToStart(element: HTMLElement, scrollStep: number) {
  if (this.smoothScrollTimeout) {
    clearTimeout(this.smoothScrollTimeout);
  }

  const scrollLeft = element.scrollLeft;

  if (scrollLeft <= 0) {
    element.scrollLeft = 0;
    this.isScrolling = false;
    return;
  }

  element.scrollLeft -= scrollStep;
  this.smoothScrollTimeout = setTimeout(() => {
    this.smoothScrollToStart(element, scrollStep);
  }, 10); // ~60fps
}

onInputChange(card): void {
  this.boardService.editedCardId=card.cardId
  this.boardService.addCommmentText=card.commentText;
}
selectUser(username: string) {
  this.selectedUser = username;
}
setFilter(){
  if(this.selectedUser==='dummy'){
    this.boardService.section = JSON.parse(JSON.stringify(this.boardService.sectionCopy));
    this.boardService.section.forEach((section) => {
      if (section.cards && Array.isArray(section.cards)) {
        section.cards.sort((a, b) => (b.cardComment.length || 0) - (a.cardComment.length || 0));
      }
    });
  }
  else if(this.selectedUser==='reacted'){
    this.boardService.section =JSON.parse(JSON.stringify(this.boardService.sectionCopy));
    this.boardService.section.forEach((section) => {
      if (section.cards && Array.isArray(section.cards)) {
        section.cards.sort((a, b) => (b.reactions.length || 0) - (a.reactions.length || 0));
      }
    });
  }
  else {
    this.boardService.section = JSON.parse((JSON.stringify([...this.boardService.sectionCopy])))
    this.boardService.section.forEach((section)=>{
      section.cards = section.cards.filter((card)=>card.user_info['username'] === this.selectedUser
    )
    })
  }
}
resetFilter(){
  this.selectedUser=''
  this.selectedUser = '';
  this.boardService.section = JSON.parse(JSON.stringify(this.boardService.sectionCopy));
  this.afterFilterList = JSON.parse(JSON.stringify([...this.boardService.section]));
}


onKeyDown(_event: KeyboardEvent): void {
  // Let ProseMirror/ngx-editor handle Enter and other keys natively.
}

applyDescFormat(command: 'bold' | 'italic' | 'underline'): void {
  document.execCommand(command, false);
}

onBoardDescInput(event: Event): void {
  this.boardDescription = (event.target as HTMLElement).innerHTML;
}

onBoardEditDescInput(event: Event): void {
  this.boardEditDesc = (event.target as HTMLElement).innerHTML;
}

onSectionDescInput(event: Event): void {
  this.sectionDesc = (event.target as HTMLElement).innerHTML;
}

onCardDescInput(event: Event): void {
  this.cardDesc = (event.target as HTMLElement).innerHTML;
}

onCardEditDescInput(event: Event): void {
  this.cardEditDesc = (event.target as HTMLElement).innerHTML;
}

clearRichDescEditors(): void {
  if (this.boardDescEditor?.nativeElement) {
    this.boardDescEditor.nativeElement.innerHTML = '';
  }
  if (this.sectionDescEditor?.nativeElement) {
    this.sectionDescEditor.nativeElement.innerHTML = '';
  }
  if (this.sectionEditDescEditor?.nativeElement) {
    this.sectionEditDescEditor.nativeElement.innerHTML = '';
  }
  if (this.cardDescEditor?.nativeElement) {
    this.cardDescEditor.nativeElement.innerHTML = '';
  }
  if (this.cardEditDescEditor?.nativeElement) {
    this.cardEditDescEditor.nativeElement.innerHTML = '';
  }
  if (this.boardEditDescEditor?.nativeElement) {
    this.boardEditDescEditor.nativeElement.innerHTML = '';
  }
}

goToGame(){  this.goGameFlag=true;
  this.showYesNoModal(this.translate.instant('gameLabel.go_game'));

}

 public checkParentWindow(){
  if (window.opener) {
    window.opener.focus(); 
    window.close();
    this.deleteBoardFlag=false;
    this.deleteSectionFlag=false;
    this.deleteCardFlag=false; 
   this.deleteCommentFlag=false 
   this.goToGameFlag=false;
  } else {
    this.deleteBoardFlag=false;
    this.deleteSectionFlag=false;
    this.deleteCardFlag=false; 
   this.deleteCommentFlag=false 
   this.goToGameFlag=false;
  }
}

clickRlLogo(){
  if(document.fullscreenElement){
  this.toggleFullScreen();
  }
  this.msgText=this.translate.instant('gameLabel.close_board');
  this.openModal('confirm1')
}

reloadPage() {
  this.commonService.loaderFlag = true;
  this.boardService.onReloadGetInfo().subscribe(
    res => {
      if (res && res.user) {
        this.commonService.applySessionUser(res.user);

        this.translate.setDefaultLang(this.commonService.selectedlang);
        this.translate.use(this.commonService.selectedlang);
        if(this.commonService.user.drole==='Gamer'){
          this.boardOptionClass='boardHeaderGamer'
        }
        else{
            this.boardOptionClass='boardHeaderOther'
        }
        if(window.opener){
          this.goToGameFlag=true;
        }
        else{
          this.goToGameFlag=false;
        }
        this.editorTitle = new Editor();
        this.editorDesc = new Editor();
        this.editorTitleSection = new Editor();
        this.editorDescSection = new Editor();
        this.editorTitleBoard = new Editor();
        this.editorDescBoard = new Editor();
        this.boardEditTitleEd=new Editor();
        this.bordEditDescEd=new Editor();
        this.sectionCreateTitle=new Editor();
        this.sectionCreateDesc=new Editor();
        this.addTitleCard=new Editor();
        this.addDescCard=new Editor();
        this._fetchProfileOptions();
        history.pushState(null, '');
        fromEvent(window, 'popstate')
          .pipe(takeUntil(this.unsubscriber))
          .subscribe((_) => {
            history.pushState(null, '');
          });
        let path='notification/user_' + this.commonService.user.id;
        const ref = this.db.database.ref(path);
        ref.on('child_changed', (snapshot) => {
          const changedChildKey = snapshot.key;
          const newData = snapshot.val();
          this.boardService.getNotification(this.commonService.user.id).subscribe(
            res=>{
              this.boardService.allNotifications=res.Result;
              this.boardService.notificationCount=res.Result.length;
              this.sweetSucees(this.translate.instant('gameLabel.New_notification_comming'));
            }
          )
        })
        
        if(this.commonService.boardIdFromGame===0){
        this.boardService.getInviteUserListForSchool().subscribe(
          res=>{
             this.boardService.users=res;
            this.boardService.getAllBoardData(this.commonService.userId).subscribe(
              res=>{
                this.allBoard=[...res.Result];
                this.commonService.loaderFlag=false;
                this.boardService.notificationCount=res.notification_count
                this.boardService.activeBoardBagImage='assets/images/Board/background-img.svg'
              }) 
          })
        }
        else{
          this.boardService.getInviteUserListForSchool().subscribe(
            res=>{
               this.boardService.users=res;
               this.selectedBoard(this.commonService.boardIdFromGame,'');
               this.boardService.getAllBoardData(this.commonService.userId).subscribe(
                res=>{
                  this.allBoard=[...res.Result];
                  this.commonService.loaderFlag=false;
                  this.boardService.notificationCount=res.notification_count
                  this.commonService.loaderFlag=false;
                  this.sweetSucees(this.translate.instant('gameLabel.card_added'));
                })
            })
        }
       if(this.commonService.user.drole==='Gamer'){
        this.boardFilterType='all'
       }
      } else {
        this.commonService.loaderFlag = false;
        console.error('No user data in response:', res);
      }
    },
    error => {
      this.commonService.loaderFlag = false;
      console.error('Error during API call:', error);
    }
  );
}
convertToSeconds(time: string): number {
  if (!time) return 0; // Handle invalid input
  const [minutes, seconds] = time.split(':').map(Number); // Split and convert to numbers
  return minutes * 60 + seconds; // Convert to total seconds
}

}


